webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
    isMobile: function isMobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },

    is_touch_device: function is_touch_device() {
        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
        return isMobile;
    },

    iOS: function iOS() {
        var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }

        return false;
    },

    isIPAD: function isIPAD() {
        var ua = navigator.userAgent;
        return (/iPad/i.test(ua) || /iPhone OS 3_1_2/i.test(ua) || /iPhone OS 3_2_2/i.test(ua)
        );
    },

    get_browser_info: function get_browser_info() {
        var ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE ', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {
                return { name: 'Opera', version: tem[1] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1]
        };
    },

    getRandomInt: function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    },

    declension: function declension(num, expressions) {
        var result;
        var count = num % 100;
        if (count >= 5 && count <= 20) {
            result = expressions['2'];
        } else {
            count = count % 10;
            if (count == 1) {
                result = expressions['0'];
            } else if (count >= 2 && count <= 4) {
                result = expressions['1'];
            } else {
                result = expressions['2'];
            }
        }
        return result;
    },

    isIE: function isIE() {
        var ua = window.navigator.userAgent;
        if (ua.indexOf('Edge/') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0) {
            return true;
        } else {
            return false;
        }
    },

    getCoords: function getCoords(elem) {
        // кроме IE8-
        var box = elem.getBoundingClientRect();

        return {
            top: box.top + pageYOffset,
            left: box.left + pageXOffset
        };
    },
    getCoordsForTransform: function getCoordsForTransform(elem, translateY) {
        // кроме IE8-
        var box = elem.getBoundingClientRect();
        return {
            top: box.top + translateY
        };
    },

    isScrolledIntoView: function isScrolledIntoView(el) {
        var elemTop = el.getBoundingClientRect().top;
        var elemBottom = el.getBoundingClientRect().bottom;
        var elHeight = elemBottom - elemTop;
        //return (elemTop >= -window.innerHeight/2) && (elemTop <= window.innerHeight/2) && (elemBottom >= window.innerHeight/2) && (elemBottom <= 3*window.innerHeight/2);
        return -elemTop >= -elHeight / 2 && elemBottom >= 0;
    },

    shareOk: function shareOk(data) {
        function sharePopup(url, width, height, callback) {
            //  console.log(url);
            if (!width) width = 400;
            if (!height) height = 400;

            var share_window = window.open(url, '_blank', 'height=' + height + ',width=' + width + ',menubar=no,toolbar=no,location=no');
            var uri_regex = new RegExp(document.location.host);
            //console.log('document.location.host',document.location.host)
            var watch_timer = setInterval(function () {
                try {
                    if (share_window.closed) {
                        clearInterval(watch_timer);
                        onShare();
                        return;
                    }
                    // console.log('share_window.location',share_window.location)
                    if (uri_regex.test(share_window.location)) {
                        clearInterval(watch_timer);
                        share_window.closed;
                        share_window.close();
                        if (typeof callback != 'undefined') {
                            callback();
                        }
                    }
                } catch (e) {}
            }, 200);
        }
        var d = {
            baseUrl: window.location.href,
            link: document.querySelector('meta[property="og:url"]') && document.querySelector('meta[property="og:url"]').getAttribute('content'),
            title: document.querySelector('meta[property="og:title"]') && document.querySelector('meta[property="og:title"]').getAttribute('content'),
            description: document.querySelector('meta[property="og:description"]') && document.querySelector('meta[property="og:description"]').getAttribute('content'),
            image: document.querySelector('meta[property="og:image"]') && document.querySelector('meta[property="og:image"]').getAttribute('content'),
            shareLink: document.querySelector('meta[property="og:url"]') && document.querySelector('meta[property="og:url"]').getAttribute('content')
        };
        var sd = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(d, data);
        sharePopup("https://connect.ok.ru/dk?cmd=WidgetSharePreview&st.cmd=WidgetSharePreview&st._aid=ExternalShareWidget_SharePreview&st.imageUrl=" + sd.image + "&st.description=" + sd.description + "&st.shareUrl=" + sd.link + "&st.title=" + sd.title, 550, 300);
    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var Recipes = [{
    title: 'Бургер с семгой',
    id: 1,
    portion: '4',
    time: '35',
    image: '/static/images/recieps/rec1.jpg',
    type: 'no-meat'
}, {
    title: 'Сэндвичи с тунцом и сыром',
    id: 2,
    portion: '4',
    time: '35',
    image: '/static/images/recieps/rec2.jpg',
    type: 'no-meat'
}, {
    title: 'Персики на гриле с горгонзолой и медом',
    id: 3,
    portion: '4',
    time: '35',
    image: '/static/images/recieps/rec3.jpg',
    type: 'no-meat'
}, {
    title: 'Овощи гриль с соусом из печеного чеснока',
    id: 4,
    portion: '2',
    time: '25',
    image: '/static/images/recieps/rec-new-gril-chesnok.jpg',
    type: 'no-meat'
}, {
    title: 'Дорада на гриле с мандаринами и майораном',
    id: 5,
    portion: '4',
    time: '35',
    image: '/static/images/recieps/rec5.jpg',
    type: 'no-meat'
}, {
    title: 'Зажаренная на гриле капуста',
    id: 6,
    portion: '4',
    time: '35',
    image: '/static/images/recieps/rec6.jpg',
    type: 'no-meat'
}, {
    title: 'Ананас на гриле с кардамоном и ванильным мороженым',
    id: 7,
    portion: '6',
    time: '15',
    image: '/static/images/recieps/rec7.jpg',
    type: 'no-meat'
}, {
    title: 'Порей с чесночным майонезом',
    id: 8,
    portion: '6',
    time: '20',
    image: '/static/images/recieps/rec8.jpg',
    type: 'no-meat'
}, {
    title: 'Овощи с грибами на гриле по‑итальянски',
    id: 9,
    portion: '4',
    time: '30',
    image: '/static/images/recieps/rec-new-gril-ital.jpg',
    type: 'no-meat'
}, {
    title: 'Бургеры из киноа',
    id: 10,
    portion: '12',
    time: '35',
    image: '/static/images/recieps/rec10.jpg',
    type: 'no-meat'
}, {
    title: 'Стейки с картофелем и спаржей на гриле',
    id: 11,
    portion: '4',
    time: '25',
    image: '/static/images/recieps/rec11.jpg',
    type: 'meat'
}, {
    title: 'Тальята',
    id: 12,
    portion: '6',
    time: '15',
    image: '/static/images/recieps/rec12.jpg',
    type: 'meat'
}, {
    title: 'Сэндвич с яичницей, беконом и сыром',
    id: 13,
    portion: '1',
    time: '5',
    image: '/static/images/recieps/rec13.jpg',
    type: 'meat'
}, {
    title: 'Шаверма в пите',
    id: 14,
    portion: '4',
    time: '60',
    image: '/static/images/recieps/rec14.jpg',
    type: 'meat'
}, {
    title: 'Ягненок на гриле с соусом персийяд',
    id: 15,
    portion: '2',
    time: '10',
    image: '/static/images/recieps/rec15.jpg',
    type: 'meat'
}, {
    title: 'Цыпленок гриль с орегано',
    id: 16,
    portion: '8',
    time: '120',
    image: '/static/images/recieps/rec16.jpg',
    type: 'meat'
}, {
    title: 'Шашлычки из курицы, креветок и овощей',
    id: 17,
    portion: '4',
    time: '35',
    image: '/static/images/recieps/rec17.jpg',
    type: 'meat'
}, {
    title: 'Ягненок тандури',
    id: 18,
    portion: '6',
    time: '70',
    image: '/static/images/recieps/rec18.jpg',
    type: 'meat'
}, {
    title: 'Говяжьи шашлычки',
    id: 19,
    portion: '4',
    time: '20',
    image: '/static/images/recieps/rec19.jpg',
    type: 'meat'
}, {
    title: 'Шашлык из страуса',
    id: 20,
    portion: '4',
    time: '30',
    image: '/static/images/recieps/rec20.jpg',
    type: 'meat'
}];

/* harmony default export */ __webpack_exports__["a"] = (Recipes);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.3 19"><path d="M42.3 9.5c0-.6-.4-1-1-1H14L17.1 0C12.7 3.8 5.7 7.4 0 9.5c5.7 2.1 12.7 5.7 17.1 9.5L14 10.5h27.3c.6 0 1-.4 1-1z"/></svg>'};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(98),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 6.1"><path d="M0 3c0-.2.1-.3.3-.3h95.2l-1-2.7c1.4 1.2 3.7 2.4 5.5 3-1.8.7-4.1 1.8-5.5 3l1-2.7H.3C.1 3.4 0 3.2 0 3z"/></svg>'};

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
// Default State


var state = {
    currentId: 0,
    bal: 0,
    RecipeDate: {
        1: {
            name: 'Бургер с семгой',
            time: '25 минут',
            portion: '8 порций',
            image: '/static/images/recieps/rec1.jpg',
            ingredients: [{
                index: 0,
                text: 'ФИЛЕ СЕМГИ',
                value: '400 г'
            }, {
                index: 1,
                text: 'ВУСТЕРШИРСКИЙ СОУС',
                value: '1 чайная ложка'
            }, {
                index: 2,
                text: 'ЛУК-РЕЗАНЕЦ',
                value: '1 столовая ложка'
            }, {
                index: 3,
                text: 'КОПЧЕНАЯ ПАПРИКА',
                value: '1 чайная ложка'
            }, {
                index: 4,
                text: 'ПОМИДОРЫ ПЛАМ',
                value: '4 штуки'
            }, {
                index: 5,
                text: 'МОЛОТЫЙ СУШЕНЫЙ ЛУК',
                value: '1 чайная ложка'
            }, {
                index: 6,
                text: 'КРАСНЫЙ ЛУК',
                value: '1,5 головки'
            }, {
                index: 7,
                text: 'ЧЕСНОК',
                value: '2,5 зубчика'
            }, {
                index: 8,
                text: 'РУБЛЕННАЯ КИНЗА (КОРИАНДР)',
                value: '1 столовая ложка'
            }, {
                index: 9,
                text: 'БЕЛЫЙ ВИННЫЙ УКСУС',
                value: '1 чайная ложка'
            }, {
                index: 10,
                text: 'ОЛИВКОВОЕ МАСЛО EXTRA VIRGIN',
                value: '1 чайная ложка'
            }, {
                index: 11,
                text: 'МАЙОНЕЗ',
                value: '400 г'
            }, {
                index: 12,
                text: 'АПЕЛЬСИНОВЫЙ СОК',
                value: '80 мл'
            }, {
                index: 13,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: '40 г'
            }, {
                index: 14,
                text: 'СЫР',
                value: '8 кусков'
            }, {
                index: 15,
                text: 'БУЛОЧКА ДЛЯ ГАМБУРГЕРОВ',
                value: '8 штук'
            }, {
                index: 16,
                text: 'ЗЕЛЕНЫЙ САЛАТ',
                value: '8 штук'
            }, {
                index: 17,
                text: 'ПОДСОЛНЕЧНОЕ МАСЛО',
                value: 'по вкусу'
            }, {
                index: 18,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Для майонеза чипотле смешать майонез (домашний или фабричный), мелко нарубленную красную луковицу, апельсиновый сок, два нарубленных зубчика чеснока и приправу чипотле. Посолить по вкусу. Мешать можно вручную, но проще блендером.'
            }, {
                id: 1,
                text: 'Для томатной сальсы удалить у помидоров семена и нарезать небольшими кубикам. Половину красной луковицы мелко нарубить. Половину зубчика чеснока натереть на терке. Перемешать лук, помидоры и чеснок с кинзой, заправить винным уксусом и оливковым маслом.'
            }, {
                id: 2,
                text: 'Три четверти семги превратить в мелкий фарш с помощью мясорубки, оставшееся — нарубить мелкими кубиками. Добавить вустерширский соус, лук-резанец, луковый порошок, копченую паприку, по вкусу посолить. Тщательно перемешать, чтобы получилась плотная однородная масса.'
            }, {
                id: 3,
                text: 'Слепить из фарша небольшие ­котлеты — восемь штук. Обжарить на подсолнечном масле на сковороде гриль — по мину­те с каждой стороны.'
            }, {
                id: 4,
                text: 'Булочки разрезать надвое, смазать обе половины майонезом чипотле. На нижние половины выложить по листу салата. Затем — по рыбной котлете с ломтиком сыра (ярлсберг), поверх сыра добавить сальсу — и накрыть верхними половинами булочек. ­Подавать с картофелем фри — или есть просто так.'
            }]
        },
        2: {
            name: 'Сэндвичи с тунцом и сыром',
            time: '10 минут',
            portion: '4 порции',
            image: '/static/images/recieps/rec2.jpg',
            ingredients: [{
                index: 0,
                text: 'КОНСЕРВИРОВАННЫЙ ТУНЕЦ В СОБСТВЕННОМ СОКУ',
                value: '1 банка'
            }, {
                index: 1,
                text: 'ХЛЕБ ДЛЯ ТОСТОВ',
                value: '8 кусков'
            }, {
                index: 2,
                text: 'СЫР ЭММЕНТАЛЬ',
                value: '200 г'
            }, {
                index: 3,
                text: 'РОЗОВЫЙ ПЕРЕЦ',
                value: 'по вкусу'
            }, {
                index: 4,
                text: 'КАПЕРСЫ',
                value: '½ чайной ложки'
            }, {
                index: 5,
                text: 'СЛИВОЧНОЕ МАСЛО',
                value: '20 г'
            }, {
                index: 6,
                text: 'ОГУРЦЫ',
                value: '½ штуки'
            }],
            instruction: [{
                id: 0,
                text: 'Тунца вместе с соком выложить в миску и размять руками. Посыпать розовым маврикийским перцем (он такой же ароматный, как черный, но менее жгучий), добавить каперсы и перемешать. Выложить тертый эмменталь (или другой сыр по вкусу — эдам, например, или гауду) и снова перемешать.'
            }, {
                id: 1,
                text: 'Разогреть сковороду на среднем огне и слегка подсушить хлеб с обеих сторон. Затем слегка промазать все куски с одной стороны сливочным маслом, выложить тунцово-сырную смесь, соединить половины сэндвичей — и снова отправить на сковородку. Там они должны провести пару минут под крышкой — идея в том, чтобы сыр расплавился и схватил рыбную массу.'
            }, {
                id: 2,
                text: 'Готовые сэндвичи разрезать по диагонали и украсить кружками огурца.'
            }]
        },
        3: {
            name: 'Персики на гриле с горгонзолой и медом',
            time: '15 минут',
            portion: '4 порции',
            image: '/static/images/recieps/rec3.jpg',
            ingredients: [{
                index: 0,
                text: 'ПЕРСИКИ',
                value: '4 штуки'
            }, {
                index: 1,
                text: 'СЫР ГОРГОНЗОЛА',
                value: '100 г'
            }, {
                index: 2,
                text: 'ЛАЙМ',
                value: '1 штука'
            }, {
                index: 3,
                text: 'МЕД',
                value: '100 г'
            }, {
                index: 4,
                text: 'КОРИЧНЕВЫЙ САХАР',
                value: '60 г'
            }, {
                index: 5,
                text: 'МЯТА',
                value: '4 стебля'
            }, {
                index: 6,
                text: 'СВЕЖЕМОЛОТЫЙ ЧЕРНЫЙ ПЕРЕЦ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Персики опустить на минуту в кипяток, остудить и снять кожицу. Разрезать на половинки и удалить косточки.'
            }, {
                id: 1,
                text: 'Посыпать половинки персиков сахаром и обжарить на гри­ле с обеих сторон (примерно по полторы минуты с каждой стороны). Положить по кусочку горгонзолы в каждую из половинок и приправить свеже­молотым перцем.'
            }, {
                id: 2,
                text: 'Помешивая, разогреть в сотейнике мед с соком лайма — до карамелизации (он начнет пениться, как масло на сковороде). ­Полить этим соусом персики и украсить листьями мяты.'
            }]
        },
        4: {
            name: 'Овощи гриль с соусом из печеного чеснока',
            time: '25 минут',
            portion: '2 порций',
            image: '/static/images/recieps/rec-new-gril-chesnok.jpg',
            ingredients: [{
                index: 0,
                text: 'СЛАДКИЙ ПЕРЕЦ',
                value: '250 г'
            }, {
                index: 1,
                text: 'ЗЕЛЕНАЯ СПАРЖА',
                value: '70 г'
            }, {
                index: 2,
                text: 'ЦУКИНИ',
                value: '250 г'
            }, {
                index: 3,
                text: 'ПЕРЕЦ ЧИЛИ',
                value: '1 штука'
            }, {
                index: 4,
                text: 'ПОМИДОРЫ ЧЕРРИ',
                value: '100 г'
            }, {
                index: 5,
                text: 'ЛУК-ШАЛОТ',
                value: '130 г'
            }, {
                index: 6,
                text: 'РОЗМАРИН',
                value: '10 г'
            }, {
                index: 7,
                text: 'КИНЗА',
                value: '30 г'
            }, {
                index: 8,
                text: 'ЧЕСНОК',
                value: '2 головки'
            }, {
                index: 9,
                text: 'САХАР',
                value: '15 г'
            }, {
                index: 10,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '115 мл'
            }, {
                index: 11,
                text: 'БАЛЬЗАМИЧЕСКИЙ УКСУС',
                value: '20 мл'
            }, {
                index: 12,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 13,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Разрежьте цукини вдоль и нарежьте его полукольцами по 1,5 см, отрежьте сухие концы спаржи, нарежьте перец и лук крупными кусками.'
            }, {
                id: 1,
                text: 'Разрежьте головки чеснока и чили перец на 2 части поперек.'
            }, {
                id: 2,
                text: 'Выложите все овощи на противень, полейте их умеренным количеством оливкового масла и уксусом, посолите, поперчите.'
            }, {
                id: 3,
                text: 'Отложите две макушки розмарина. Остальными веточками розмарина посыпьте овощи и запекайте в разогретой до 250 градусов духовке в режиме вертикального гриля в течение 10 минут.'
            }, {
                id: 4,
                text: 'Переложите овощи в емкость, достаньте чеснок, накройте остальные овощи фольгой.'
            }, {
                id: 5,
                text: 'Выдавите зубчики чеснока и поместите их в емкость; добавьте кинзу со стеблем, сахар, посолите, поперчите, добавьте 80 мл оливкового масла и пробейте блендером в крупную крошку.'
            }, {
                id: 6,
                text: 'Перемешайте овощи с 2/3 соуса, разложите по тарелкам, украсьте макушками розмарина и подавайте. Оставшийся соус подайте в пиалке.'
            }]
        },
        5: {
            name: 'Дорада на гриле с мандаринами и майораном',
            time: '20 минут',
            portion: '4 порции',
            image: '/static/images/recieps/rec5.jpg',
            ingredients: [{
                index: 0,
                text: 'МАЙОРАН',
                value: '1 пучок'
            }, {
                index: 1,
                text: 'ДОРАДО',
                value: '2 штуки'
            }, {
                index: 2,
                text: 'МАНДАРИНЫ',
                value: '2 штуки'
            }, {
                index: 3,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '20 мл'
            }, {
                index: 4,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 5,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Хорошо разогреть гриль. На выпотрошенных тушках рыбы сделать с одной стороны по три глубоких диагональных надре­за на расстоянии в 2–3 см. Натереть солью и перцем кожу и брюшки.'
            }, {
                id: 1,
                text: 'Нафаршировать каждую рыбу четырьмя целыми веточками майорана и дольками одного мандарина (нужно распределить их поровну между двумя тушками). Тщательно смазать дораду оливковым маслом со всех сторон.'
            }, {
                id: 2,
                text: 'Жарить на гриле по 3–4 минуты с каждой стороны, затем переложить рыбу на сервировочное блюдо и украсить дольками оставшегося мандарина, а также посыпать листьями c оставшихся веточек майорана.'
            }]
        },
        6: {
            name: 'Зажаренная на гриле капуста',
            time: '40 минут',
            portion: '8 порции',
            image: '/static/images/recieps/rec6.jpg',
            ingredients: [{
                index: 0,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 1,
                text: 'БЕЛОКОЧАННАЯ КАПУСТА',
                value: '3 кг'
            }, {
                index: 2,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            }, {
                index: 3,
                text: 'ТОПЛЕНОЕ МАСЛО',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Кочаны капусты выложить на ­хорошо разогретый гриль и закрыть крышкой сверху. В жаре и дыму капуста отлично запечется примерно за полчаса. Можно в течение этого времени кочан несколько раз перевернуть, чтобы его листья обгорали равномерно со всех сторон.'
            }, {
                id: 1,
                text: 'Сгоревшие листья надо оборвать, капусту нарезать большими кусками, посолить, поперчить, а также — для усиления вкуса — полить растопленным тут же на гриле в подходящей емкости маслом.'
            }]
        },
        7: {
            name: 'Ананас на гриле с кардамоном и ванильным мороженым',
            time: '15 минут',
            portion: '6 порции',
            image: '/static/images/recieps/rec7.jpg',
            ingredients: [{
                index: 0,
                text: 'ПАТОКА',
                value: '50 г'
            }, {
                index: 1,
                text: 'СЛИВОЧНОЕ МАСЛО',
                value: '60 г'
            }, {
                index: 2,
                text: 'КОРОБОЧКИ КАРДАМОНА',
                value: '8 штук'
            }, {
                index: 3,
                text: 'СОК ЛАЙМА',
                value: '2 чайные ложки'
            }, {
                index: 4,
                text: 'АНАНАС',
                value: '1 штука'
            }, {
                index: 5,
                text: 'АРАХИСОВОЕ МАСЛО',
                value: '2 столовые ложки'
            }, {
                index: 6,
                text: 'ВАНИЛЬНОЕ МОРОЖЕНОЕ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Разогреть гриль. Ананас очистить, удалить сердцевину и нарезать кружками толщиной 5 мм. Смешать патоку и масло в сотейнике, добавить раздавленные коробочки кардамона, довести до кипения и варить пять минут. Снять с огня, влить сок лайма.'
            }, {
                id: 1,
                text: 'Смазать кольца сиропом и поджарить с двух сторон в течение четырех минут, а за тридцать секунд до готовности смазать еще раз, чтобы глазурь получилась плотной. Подавать с ваниль­ным мороженым.'
            }]
        },
        8: {
            name: 'Порей с чесночным майонезом',
            time: '20 минут',
            portion: '6 порции',
            image: '/static/images/recieps/rec8.jpg',
            ingredients: [{
                index: 0,
                text: 'СЛАДКИЙ ПЕРЕЦ',
                value: '1 штука'
            }, {
                index: 1,
                text: 'ЛУК-ПОРЕЙ',
                value: '36 стеблей'
            }, {
                index: 2,
                text: 'ЛИМОН',
                value: '1 штука'
            }, {
                index: 3,
                text: 'ЧЕСНОК',
                value: '8 зубчиков'
            }, {
                index: 4,
                text: 'МАЙОНЕЗ',
                value: '500 г'
            }, {
                index: 5,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 6,
                text: 'ШАФРАН',
                value: 'на кончике ножа'
            }],
            instruction: [{
                id: 0,
                text: 'Шепотку шафрана развести в двадцати миллилитрах кипятка. Сладкий перец обжарить на гриле так, чтобы кожица начала лопаться и обугливаться. Снять с огня, срезать по максимуму всю кожицу, выкинуть семечки и прочую начинку и мелко нарубить перец. Дать шафрану настояться пять минут и смешать настой с майонезом, мелко нарубленным перцем, давленым чесноком, соком лимона и солью.'
            }, {
                id: 1,
                text: 'Стебли порея обжарить на решетке над костром, не смущаясь того, что верхние слои начнут обугливаться и подгорать. Обжаривать минут пять, постоян­но переворачивая. Снять порей с огня и есть, обрывая верхние — обожженные слои и макая в острый чесночный майонез.'
            }]
        },
        9: {
            name: 'Овощи с грибами на гриле по‑итальянски',
            time: '30 минут',
            portion: '4 порции',
            image: '/static/images/recieps/rec-new-gril-ital.jpg',
            ingredients: [{
                index: 0,
                text: 'КРАСНЫЙ ЛУК',
                value: '4 головки'
            }, {
                index: 1,
                text: 'КРАСНЫЙ СЛАДКИЙ ПЕРЕЦ',
                value: '4 штуки'
            }, {
                index: 2,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '2 чайные ложки'
            }, {
                index: 3,
                text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                value: 'по вкусу'
            }, {
                index: 4,
                text: 'ГРИБЫ ПОРТОБЕЛЛО',
                value: '6 штук'
            }, {
                index: 5,
                text: 'СВЕЖАЯ СПАРЖА',
                value: '900 г'
            }],
            instruction: [{
                id: 0,
                text: 'Приготовьте чесночный винегрет с чили'
            }, {
                id: 1,
                text: 'Разогрейте гриль или мангал.'
            }, {
                id: 2,
                text: 'Разрежьте перцы пополам и очистите, луковицы порежьте на 6 кусков. Сбрызните растительным маслом и перемешайте.'
            }, {
                id: 3,
                text: 'Выложите перцы и лук на гриль и жарьте примерно 15 минут, переворачивая, пока кожица у перцев не станет подгорать. Переложите перцы в пластиковый пакет и оставьте на 15 минут. Очистите от кожицы и порежьте на длинные полоски. Переложите в миску.'
            }, {
                id: 4,
                text: 'Порежьте лук на небольшие кусочки и добавьте к перцам.'
            }, {
                id: 5,
                text: 'Сбрызните спаржу и грибы оливковым маслом, перемешайте и выложите на гриль. Жарьте, переворачивая, примерно 3 минуты до мягкости.'
            }, {
                id: 6,
                text: 'Порежьте грибы на небольшие кусочки и добавьте к луку и перцам. Затем порежьте спаржу по диагонали на небольшие кусочки и переложите к овощам. Сбрызните приготовленным чесночным винегретом и аккуратно перемешайте.'
            }]
        },

        10: {
            name: 'Бургеры из киноа',
            time: '35 минут',
            portion: '12 порций',
            image: '/static/images/recieps/rec10.jpg',
            ingredients: [{
                index: 0,
                text: 'КИНОА',
                value: '250 г'
            }, {
                index: 1,
                text: 'ЯЙЦО КУРИНОЕ',
                value: '1 штука'
            }, {
                index: 2,
                text: 'ТВОРОГ',
                value: '120 г'
            }, {
                index: 3,
                text: 'КРАСНЫЙ ЛУК',
                value: '1 головка'
            }, {
                index: 4,
                text: 'ПЕРЬЯ ЧЕСНОКА',
                value: '40 г'
            }, {
                index: 5,
                text: 'ПЕРЕЦ ЧИЛИ',
                value: '1 штука'
            }, {
                index: 6,
                text: 'РИСОВАЯ МУКА',
                value: '2,5 столовые ложки'
            }, {
                index: 7,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: 'по вкусу'
            }, {
                index: 8,
                text: 'КУМИН (ЗИРА)',
                value: '2 чайные ложки'
            }, {
                index: 9,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 9,
                text: 'ТЕРТЫЙ СЫР ПАРМЕЗАН',
                value: '30 г'
            }],
            instruction: [{
                id: 0,
                text: 'Промыть киноа, залить водой в соотношении 1:2, довести до кипения и варить одиннадцать минут. Остудить.'
            }, {
                id: 1,
                text: 'В остывшую киноа добавить слегка взбитое яйцо, мелко на­резанные зеленые побеги чес­нока (или черемшу), перец чили и среднюю красную луковицу, нежирный сухой творог, тертый сыр — вместо пармезана можно взять чеддер. Все хорошо перемешать.'
            }, {
                id: 2,
                text: 'Посолить фарш, добавить одну столовую ложку рисовой муки. Смесь должна получиться густой и липкой.'
            }, {
                id: 3,
                text: 'Сформировать нетолстые бургеры, слегка присыпать их рисовой мукой и обжарить на оливковом масле. Подавать с острым томатным или перечным соусом.'
            }]
        },
        11: {
            name: 'Стейки с картофелем и спаржей на гриле',
            time: '25 минут',
            portion: '4 порции',
            image: '/static/images/recieps/rec11.jpg',
            ingredients: [{
                index: 0,
                text: 'ГОВЯЖИЙ СТЕЙК',
                value: '4 штуки'
            }, {
                index: 1,
                text: 'КАРТОФЕЛЬ',
                value: '8 штук'
            }, {
                index: 2,
                text: 'СПАРЖА',
                value: '12 стеблей'
            }, {
                index: 3,
                text: 'ЛИМОН',
                value: '½ штуки'
            }, {
                index: 4,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '60 мл'
            }, {
                index: 5,
                text: 'СЛИВОЧНОЕ МАСЛО',
                value: '60 г'
            }, {
                index: 6,
                text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                value: '80 г'
            }, {
                index: 7,
                text: 'РОЗМАРИН',
                value: '1 г'
            }, {
                index: 8,
                text: 'ТИМЬЯН',
                value: '1 г'
            }, {
                index: 9,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 10,
                text: 'СВЕЖИЙ ПЕРЕЦ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Картофель отварить, сняв с огня за пару минут до готовности, — он должен остаться твердым. Дать остыть, разрезать вдоль на половинки.'
            }, {
                id: 1,
                text: 'Спаржу очистить, опустить в кипящую воду на две минуты, затем переложить на минуту в воду со льдом — холод помогает сохранить цвет продукта, в тепле спаржа станет рыжеватого цвета.'
            }, {
                id: 2,
                text: 'С веток тимьяна и розмарина оборвать листья, мелко нарезать их. Втереть в зелень соль, чтобы листья дали больше сока, поперчить, залить 60 мл оливкового масла и лимонным соком, хоро­шо перемешать.'
            }, {
                id: 3,
                text: 'Стейки поперчить и обжарить на сковороде гриль (на рас­тительном масле), картофель и спар­жу тоже поперчить и обжарить отдельно, тоже на сковороде гриль, но на сливочном, до зо­лотистой корочки. Во вре­мя жарки полить овощи заправкой из сока лимона, оливкового масла и пряных трав.'
            }]
        },
        12: {
            name: 'Тальята',
            time: '15 минут',
            portion: '6 порций',
            image: '/static/images/recieps/rec12.jpg',
            ingredients: [{
                index: 0,
                text: 'ЛИМОН',
                value: '1 штука'
            }, {
                index: 1,
                text: 'ЧЕСНОК',
                value: '4 зубчика'
            }, {
                index: 2,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '100 мл'
            }, {
                index: 3,
                text: 'РОЗМАРИН',
                value: '4 стебля'
            }, {
                index: 4,
                text: 'РУККОЛА',
                value: '150 г'
            }, {
                index: 5,
                text: 'СЫР ПАРМЕЗАН',
                value: '100 г'
            }, {
                index: 6,
                text: 'СИРЛОЙН-СТЕЙК',
                value: '900 г'
            }, {
                index: 7,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            }, {
                index: 8,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 9,
                text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                value: '30 мл'
            }],
            instruction: [{
                id: 0,
                text: 'Нежирный стейк сирлойн толщиной примерно 1 см просушить бумажными салфетками и посолить. Раскалить сковороду, спрыснутую растительным маслом, оно защитит мясо от прилипания к горячей поверхности. Раскалить, пока масло не начнет чуть-чуть дымить.'
            }, {
                id: 1,
                text: 'Бросить мясо на сковороду и жарить две-три минуты (в зависимости от того, какая степень прожарки нужна: две минуты для medium rare, три — medium), переворачивая каждые двадцать секунд. Частота вра­щения также позволяет мясу не подгорать и не образовывать толстую корку.'
            }, {
                id: 2,
                text: 'Готовый стейк положить на решетку и подставить тарелку, чтобы в нее стекал мясной сок.'
            }, {
                id: 3,
                text: 'Из сковороды слить масло, но не выбрасывать прижарившиеся кусочки. Залить горячую сковороду оливковым маслом, бросить два раздавленных зубчика чеснока, иголки розмарина и цедру половины лимона.'
            }, {
                id: 4,
                text: 'Дать маслу пять минут настояться в остывающей сковороде, выжать в него сок лимона, процедить через мелкое сито и смешать с соком, вытекшим из поджаренного мяса.'
            }, {
                id: 5,
                text: 'Нарезать стейк тонкими ломтиками, полить частью соуса, посолить и поперчить. Сверху разложить смешанную с соусом рукколу, посыпать пармезаном.'
            }]
        },
        13: {
            name: 'Сэндвич с яичницей, беконом и сыром',
            time: '5 минут',
            portion: '1 порция',
            image: '/static/images/recieps/rec13.jpg',
            ingredients: [{
                index: 0,
                text: 'БЕКОН',
                value: '10 г'
            }, {
                index: 1,
                text: 'БЕЛЫЙ ХЛЕБ',
                value: '½ штуки'
            }, {
                index: 2,
                text: 'СЫР ЭДАМ',
                value: '20 г'
            }, {
                index: 3,
                text: 'ПОМИДОРЫ',
                value: '1 штука'
            }, {
                index: 4,
                text: 'МАЙОНЕЗ',
                value: '1 столовая ложка'
            }, {
                index: 5,
                text: 'СЛИВОЧНОЕ МАСЛО',
                value: '10 г'
            }, {
                index: 6,
                text: 'ЯЙЦО КУРИНОЕ',
                value: '1 штука'
            }, {
                index: 7,
                text: 'ЛИСТЬЯ ЛАТУКА',
                value: '3 штуки'
            }],
            instruction: [{
                id: 0,
                text: 'Поджарить тонкие ломтики бекона до золотистой корочки.'
            }, {
                id: 1,
                text: 'Подогреть хлеб и одну половину сэндвича намазать майонезом (можно приготовить самостоятельно), на вторую положить сыр, ломтики помидоров, бекон и латук.'
            }, {
                id: 2,
                text: 'Тем временем на сливочном масле поджарить небольшую глазунью — такую, чтобы желток был полуготовым.'
            }, {
                id: 3,
                text: 'Выложить глазунью на латук, закрыть другой половинкой сэндвича и подавать.'
            }]
        },
        14: {
            name: 'Шаверма в пите',
            time: '1 ЧАС + 1 ЧАС',
            portion: '4 порции',
            image: '/static/images/recieps/rec14.jpg',
            ingredients: [{
                index: 0,
                text: 'ПИТА',
                value: '4 штуки'
            }, {
                index: 1,
                text: 'КУРИНОЕ ФИЛЕ',
                value: '2 куска'
            }, {
                index: 2,
                text: 'ПОМИДОРЫ',
                value: '3 штуки'
            }, {
                index: 3,
                text: 'ЗЕЛЕНЬ',
                value: 'по вкусу'
            }, {
                index: 4,
                text: 'ОГУРЦЫ',
                value: '2 штуки'
            }, {
                index: 5,
                text: 'МАЙОНЕЗ',
                value: '6 столовых ложек'
            }, {
                index: 6,
                text: 'СМЕТАНА',
                value: '6 столовых ложек'
            }, {
                index: 7,
                text: 'РЯЖЕНКА',
                value: '6 столовых ложек'
            }, {
                index: 8,
                text: 'ЧЕСНОК',
                value: 'по вкусу'
            }, {
                index: 9,
                text: 'КУРИНЫЙ БУЛЬОННЫЙ КУБИК',
                value: '½ штуки'
            }, {
                index: 10,
                text: 'КАРРИ',
                value: 'по вкусу'
            }, {
                index: 11,
                text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Смешать майонез, сметану и ряженку в соотношении 1:1:1. Выдавить через чеснокодавилку чеснок. Раскрошить бульонный кубик. Нарезать зелень. Все тщательно перемешать. Закрыть крышкой и убрать в холодильник минимум на час. Соус должен настояться, чем дольше стоит, тем вкуснее будет.'
            }, {
                id: 1,
                text: 'Промыть, просушить. Нарезать на небольшое кусочки. Разогреть растительное масло, выложить курицу, посыпать карри. Обжаривать до румяной корочки. Перед сборкой покромсать, я для этого использую ножницы.'
            }, {
                id: 2,
                text: 'Нарезать салат из помидоров и огурцов небольшими кубиками. (овощи можете добавлять какие душе угодно)'
            }, {
                id: 3,
                text: 'Питу готовим перед подачей. Ее нужно раскрыть, чтобы получились конвертики, можно разрезать пополам, тогда получится много маленьких шаверм. Капнуть на сковороду капельку масла, разогреть. Обжарить питу буквально несколько секунд с обеих сторон.'
            }, {
                id: 4,
                text: 'Далее собираем шаверму. Я все выкладываю слоями: соус, курица, соус, салат, соус, курица, соус, салат, соус. А можно все ингредиенты смешать.'
            }]
        },
        15: {
            name: 'Ягненок на гриле с соусом персийяд',
            time: '40 МИНУТ + 1 ЧАС',
            portion: '2 ПОРЦИИ',
            image: '/static/images/recieps/rec15.jpg',
            ingredients: [{
                index: 0,
                text: 'ЧЕСНОК',
                value: '1 головка'
            }, {
                index: 1,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '240 мл'
            }, {
                index: 2,
                text: 'КАРЕ ЯГНЕНКА',
                value: '450 г'
            }, {
                index: 3,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 4,
                text: 'ПОРТВЕЙН',
                value: '100 мл'
            }, {
                index: 5,
                text: 'ПЕТРУШКА',
                value: '1 пучок'
            }, {
                index: 6,
                text: 'СВЕЖИЙ РОЗМАРИН',
                value: '2 стебля'
            }, {
                index: 7,
                text: 'ЧЕСНОЧНОЕ МАСЛО',
                value: '100 мл'
            }, {
                index: 8,
                text: 'ХЕРЕСНЫЙ УКСУС',
                value: '2 столовые ложки'
            }, {
                index: 9,
                text: 'САХАР',
                value: '100 г'
            }, {
                index: 10,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Чеснок разобрать на зубчики, три отложить, остальные залить в сотейнике 180 мл оливкового масла. На слабом огне томить час, не давая закипеть. За это время чеснок станет прозрачным и мягким. Остудить.'
            }, {
                id: 1,
                text: 'Оставшееся оливковое масло и 30 мл портвейна смешать с тремя зубчиками чеснока, стеблями петрушки (листья оборвать и сохранить), веточкой розмарина и парой щепоток черного перца. Влить маринад в емкость для запекания и погрузить в него куски ягненка. Затянуть пленкой и убрать в холодильник на час.'
            }, {
                id: 2,
                text: 'Для персийяда смешать томленый чеснок с чесночным маслом, уксусом, измельченными листьями петрушки и розмарина, посолить и поперчить. В сотейнике смешать сахар, оставшийся портвейн, щепотку соли и на среднем огне уварить на две трети.'
            }, {
                id: 3,
                text: 'Разогреть гриль. Мясо выложить на решетку и поджарить до корочки с обеих сторон, переложить на тарелки и полить сиропом. Подавать с соусом персийяд.'
            }]
        },

        16: {
            name: 'Цыпленок гриль с орегано',
            time: '2 ЧАСА + 1 СУТКи',
            portion: ' 8 ПОРЦИЙ',
            image: '/static/images/recieps/rec16.jpg',
            ingredients: [{
                index: 0,
                text: 'ЛИМОН',
                value: '5 штук'
            }, {
                index: 1,
                text: 'БЕЛОЕ СУХОЕ ВИНО',
                value: '100 мл'
            }, {
                index: 2,
                text: 'ОЛИВКОВОЕ МАСЛО EXTRA VIRGIN',
                value: '120 мл'
            }, {
                index: 3,
                text: 'СВЕЖИЕ ЛИСТЬЯ ОРЕГАНО',
                value: '60 г'
            }, {
                index: 4,
                text: 'ЛУК РЕПЧАТЫЙ',
                value: '½ головки'
            }, {
                index: 5,
                text: 'ЦЫПЛЕНОК',
                value: '4 кг'
            }, {
                index: 6,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 7,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            }, {
                index: 8,
                text: 'ЛИСТЬЯ ТИМЬЯНА',
                value: '20 г'
            }],
            instruction: [{
                id: 0,
                text: '90 мл свежевыжатого лимонного сока, вино, 100 мл оливкового масла, орегано, тимьян, а также чайную ложку соли, пол чайной ложки черного перца и лук взбить в комбайне. Перелить в герметичную емкость и убрать в холодильник на ночь.'
            }, {
                id: 1,
                text: 'У цыплят удалить шеи, грудинные кости и хребты (в 49-м номере «Афиши–Еда» можно найти мастер-класс, где на примере утки показана техника избавления птицы от костей). Поместить тушки в миску, посолить и поперчить, залить маринадом и поставить в холодильник на двенадцать часов.'
            }, {
                id: 2,
                text: 'Разогреть гриль. Деревянными шампурами проткнуть тушки поперек в области грудок под крылышками и в области бедер так, чтобы обе голени оказались скреплены. Так цыплята прожарятся равномерно.'
            }, {
                id: 3,
                text: 'Оставшиеся целые лимоны разрезать пополам, срезы смазать оливковым маслом и посыпать солью и перцем.'
            }, {
                id: 4,
                text: 'Выложить цыплят на решетку кожей вниз и жарить под крышкой десять минут. Затем повернуть на 90 градусов по часовой стрелке, снова закрыть и жарить десять минут. Так же повернуть еще дважды, потом перевернуть кожей вверх и жарить двадцать минут, каждые пять минут поворачивая на 90 градусов. Переложить готовых цыплят на блюдо, а на гриль срезами вниз выложить лимоны на пятнадцать минут.'
            }, {
                id: 5,
                text: 'Из цыплят вынуть шампуры, тушки разрезать на четыре части. Подавать с лимонными доль­ками.'
            }]
        },
        17: {
            name: 'Шашлычки из курицы, креветок и овощей',
            time: '15 МИНУТ + 1 ЧАС',
            portion: '2 ПОРЦИИ',
            image: '/static/images/recieps/rec17.jpg',
            ingredients: [{
                index: 0,
                text: 'КУРИНОЕ ФИЛЕ',
                value: '300 г'
            }, {
                index: 1,
                text: 'КРЕВЕТКИ',
                value: '300 г'
            }, {
                index: 2,
                text: 'ГРИБЫ ШИИТАКЕ',
                value: '150 г'
            }, {
                index: 3,
                text: 'ПОМИДОРЫ ЧЕРРИ',
                value: '150 г'
            }, {
                index: 4,
                text: 'СОЕВЫЙ СОУС',
                value: '40 мл'
            }, {
                index: 5,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 6,
                text: 'СВЕЖИЙ ИМБИРЬ',
                value: '20 г'
            }],
            instruction: [{
                id: 0,
                text: 'Имбирь очистить и натереть на крупной терке. Курицу нарезать небольшими кусочками, креветки, если нужно, очистить от панциря и избавить от темной жилки-пищевода. Натереть курицу и креветки солью, перемешать с имбирем (все это надо делать в разной посуде) и оставить настояться в этом маринаде креветки и курицу — примерно на час.'
            }, {
                id: 1,
                text: 'Подготовить посуду: лучше, чтобы это была сковорода гриль. Обычная тоже подойдет, но она должна быть такой, чтобы шпажки с мясом полностью в нее помещались.'
            }, {
                id: 2,
                text: 'Замаринованное куриное мясо и креветки нанизать на бамбуковые шпажки, оставляя между кусочками небольшое расстояние. Для овощного шашлыка — по очереди черри и шиитаке.'
            }, {
                id: 3,
                text: 'Сковороду хорошо разогреть и на сильном огне обжарить все шашлыки, периодически переворачивая, в конце каждый шашлычок сбрызнуть соевым соусом. Но важно не перестараться — все зависит от коли­чества соли, добавленной в маринад.'
            }]
        },
        18: {
            name: 'Ягненок тандури',
            time: '1 ЧАС 10 МИНУТ + 8 ЧАСОВ',
            portion: '6 ПОРЦИЙ',
            image: '/static/images/recieps/rec18.jpg',
            ingredients: [{
                index: 0,
                text: 'РЕБРА ЯГНЕНКА',
                value: '900 г'
            }, {
                index: 1,
                text: 'КУМИН (ЗИРА)',
                value: '1 столовая ложка'
            }, {
                index: 2,
                text: 'ГАРАМ-МАСАЛА',
                value: '1 столовая ложка'
            }, {
                index: 3,
                text: 'ЧЕСНОК',
                value: '8 зубчиков'
            }, {
                index: 4,
                text: 'СВЕЖИЙ ИМБИРЬ',
                value: '20 г'
            }, {
                index: 5,
                text: 'СОЛОДОВЫЙ УКСУС',
                value: '60 мл'
            }, {
                index: 6,
                text: 'ГРЕЧЕСКИЙ ЙОГУРТ',
                value: '125 мл'
            }, {
                index: 7,
                text: 'КАЙЕНСКИЙ ПЕРЕЦ',
                value: '3 чайные ложки'
            }, {
                index: 8,
                text: 'КРАСНЫЙ ПИЩЕВОЙ КРАСИТЕЛЬ',
                value: '1,5 чайные ложки'
            }, {
                index: 9,
                text: 'МОЛОТЫЙ КАРДАМОН',
                value: '2 чайные ложки'
            }, {
                index: 10,
                text: 'МУСКАТНЫЙ ОРЕХ',
                value: '1 чайная ложка'
            }, {
                index: 11,
                text: 'ЛИМОН',
                value: '1 штука'
            }, {
                index: 12,
                text: 'СЛИВОЧНОЕ МАСЛО',
                value: 'по вкусу'
            }, {
                index: 13,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }, {
                index: 14,
                text: 'СОЛЬ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'ложить ребра в глубокий противень. На сковороде обжарить кумин и гарам-масала в течение тридцати секунд, остудить. Растереть в порошок. Чеснок и имбирь взбить в блендере, добавить кумин и гарам-масала, йогурт, уксус, кайенский перец, кардамон, краситель, мускатный орех, соль, перец и сок лимона. Залить ребра и поставить в холодильник на ночь.'
            }, {
                id: 1,
                text: 'Разогреть гриль. Обжаривать ребра с двух сторон двадцать минут. Слегка остудить и полить растопленным маслом.'
            }]
        },
        19: {
            name: 'Говяжьи шашлычки',
            time: '20 МИНУТ + 4 ЧАСА',
            portion: '4 ПОРЦИИ',
            image: '/static/images/recieps/rec19.jpg',
            ingredients: [{
                index: 0,
                text: 'СОЕВЫЙ СОУС',
                value: '80 мл'
            }, {
                index: 1,
                text: 'ГОВЯЖЬЕ ФИЛЕ',
                value: '800 г'
            }, {
                index: 2,
                text: 'КИНЗА',
                value: '50 г'
            }, {
                index: 3,
                text: 'ЦЕДРА АПЕЛЬСИНА',
                value: '2 столовые ложки'
            }, {
                index: 4,
                text: 'РЫБНЫЙ СОУС',
                value: '4 столовые ложки'
            }, {
                index: 5,
                text: 'КОРИЧНЕВЫЙ САХАР',
                value: '1,5 чайные ложки'
            }, {
                index: 6,
                text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                value: '1 чайная ложка'
            }, {
                index: 7,
                text: 'ЧЕСНОК',
                value: '3 зубчика'
            }],
            instruction: [{
                id: 0,
                text: 'Соевый соус, кинзу, цедру апельсина, рыбный соус, сахар, масло и чеснок взбить в блендере. Говядину нарезать на тонкие полоски толщиной в 5 мм и шириной в 2 см. Смешать в миске с маринадом. Оставить на четыре часа.'
            }, {
                id: 1,
                text: 'Разогреть гриль. Нанизать мясо на деревянные шампуры и поджарить в течение пяти минут, один раз в процессе приготовления перевернув. Сразу подавать. Шампуры предварительно лучше вымочить в воде в течение получаса, чтобы они не сгорели на решетке. Или использовать стальные.'
            }]
        },
        20: {
            name: 'Шашлык из страуса',
            time: '30 МИНУТ',
            portion: '4 ПОРЦИИ',
            image: '/static/images/recieps/rec20.jpg',
            ingredients: [{
                index: 0,
                text: 'ФИЛЕ СТРАУСА',
                value: '1 кг'
            }, {
                index: 1,
                text: 'ЛУК РЕПЧАТЫЙ',
                value: '1 головка'
            }, {
                index: 2,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '2 столовые ложки'
            }, {
                index: 3,
                text: 'СОЛЬ',
                value: '1 чайная ложка'
            }, {
                index: 4,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            }],
            instruction: [{
                id: 0,
                text: 'Филе страуса нарезать на куски среднего размера.'
            }, {
                id: 1,
                text: 'Лук нарезать полукольцами и перемешать его с мясом. Сбрызнуть шашлык оливковым маслом, посолить и поперчить. Оставить мариноваться на два часа. Два часа — это максимум, страусиное мясо быстро впитывает все необходимое.'
            }, {
                id: 2,
                text: 'Выложить мясо на решетку над огнем и обжарить с двух сторон. Идеальная прожарка — средняя, то есть medium или medium rare.'
            }]
        }
    }
};

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.6 155.1"><path class="st0" d="M52.3 155.1V84.4H76l3.6-27.6H52.3V39.2c0-8 2.2-13.4 13.7-13.4h14.6V1.1C78 .8 69.4 0 59.3 0 38.2 0 23.8 12.9 23.8 36.5v20.3H0v27.6h23.8v70.8h28.5z"/></svg>'};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 133.5 17.7"><defs><path id="a" d="M0 0h133.5v17.7H0z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><path class="st0" d="M133.5 3.4c0 .5-.1.9-.3 1.3-.2.4-.4.8-.7 1.1-.3.3-.6.5-1 .7-.4.2-.8.3-1.3.3s-.9-.1-1.3-.3c-.4-.2-.8-.4-1.1-.7-.3-.3-.5-.7-.7-1.1-.2-.4-.3-.8-.3-1.3s.1-.9.3-1.3c.2-.4.4-.8.7-1.1.3-.3.6-.5 1.1-.7.4-.2.8-.3 1.3-.3s.9.1 1.3.3c.4.2.7.4 1 .7.3.3.5.7.7 1.1.2.3.3.8.3 1.3m-.6 0c0-.4-.1-.8-.2-1.1-.1-.3-.3-.6-.6-.9-.2-.3-.5-.5-.9-.6-.3-.1-.7-.2-1.1-.2-.4 0-.8.1-1.1.2-.3.1-.6.3-.9.6l-.6.9c-.1.3-.2.7-.2 1.1 0 .4.1.7.2 1.1.1.3.3.6.6.9.2.3.5.4.9.6.3.1.7.2 1.1.2.4 0 .7-.1 1.1-.2.3-.1.6-.3.9-.6.2-.2.4-.5.6-.9.1-.4.2-.8.2-1.1m-3.5 1.8v.1h-.5V1.7c0-.2.1-.3.3-.3h1.3c.4 0 .7.1.9.3.2.2.3.5.3.8 0 .2-.1.4-.2.6-.1.2-.3.3-.4.4.1.1.3.1.3.2.1.1.1.2.1.3l.3 1.1v.1l-.1.1h-.4c-.1 0-.1 0-.1-.1l-.3-1.1c0-.2-.1-.3-.3-.4-.1-.1-.3-.1-.5-.1h-.8v1.6zm1.7-2.7c0-.1 0-.3-.2-.4-.1-.1-.3-.2-.5-.2h-.9v1.2h.9c.3 0 .4-.1.6-.2 0-.1.1-.2.1-.4M9.7 10.3c-.4-.5-.9-.9-1.5-1.2-.7-.3-1.5-.5-2.6-.5H2.7V6.1h5.7c.3 0 .5-.1.6-.3.1-.1.1-.3.1-.4v-1c0-.2 0-.3-.1-.4-.1-.2-.3-.3-.6-.3H1.6c-.5 0-.8.1-1.1.4-.3.3-.5.7-.5 1.2V16c0 .5.1.8.3 1 .2.2.6.3 1 .3h4.4c.6 0 1.2-.1 1.8-.3.6-.2 1.1-.5 1.5-.9.4-.4.8-.9 1-1.4.3-.5.4-1.1.4-1.8 0-.4 0-.8-.1-1.3 0-.3-.3-.8-.6-1.3m-2 2.6c0 .2 0 .4-.1.7l-.3.6c-.2.2-.4.4-.6.5-.3.1-.6.2-1.1.2H2.7V11h2.9c.4 0 .7 0 1 .1.3.1.5.2.6.4.2.2.3.4.4.6.1.3.1.6.1.8M18.3 4.7c-.1-.4-.3-.7-.5-.8-.2-.2-.5-.3-1-.3h-.6c-.4 0-.7.1-.9.3-.2.2-.4.4-.5.8l-4.1 11.8c-.1.2-.1.4 0 .6.1.1.2.3.6.3h1.4c.2 0 .4-.1.5-.2.1-.1.2-.2.3-.4l.8-2.4h4.5l.8 2.4c0 .1.1.4.4.5.1 0 .3.1.4.1h1.4c.4 0 .5-.2.6-.3.1-.1.1-.3 0-.6L18.3 4.7zm-.3 7.4h-2.9l1.4-4.7 1.5 4.7zM32.8 12.3c-.1-.3-.2-.5-.2-.8-.1-.3-.2-.5-.4-.7l-.6-.6c-.1-.1-.2-.1-.3-.2.6-.5 1-1.2 1.2-2.2l.8-3.3c.1-.1.1-.3 0-.4 0-.1-.1-.5-.7-.5h-1.2c-.1 0-.2 0-.3.1-.1 0-.4.2-.4.5l-.8 3.1c-.1.4-.2.7-.4.9-.1.2-.3.4-.4.4-.2.1-.3.2-.5.2s-.4.1-.5.1h-1.9V4.5c.1-.4-.1-.6-.2-.6-.1-.1-.3-.1-.5-.1h-1.2c-.2 0-.3 0-.4.1-.1.1-.3.2-.3.6v12.4c0 .4.2.5.3.6.1.1.3.1.4.1h1.2c.2 0 .3 0 .5-.1s.2-.3.2-.6v-5.4h2.1c.6 0 1 .1 1.3.3.3.2.5.6.7 1.1l1.1 4.1c.1.3.3.4.4.5.1 0 .2.1.3.1h1.3c.5 0 .6-.3.6-.4v-.4l-1.2-4.5zM43.8 3.7h-9.2c-.3 0-.5.1-.6.3-.1.1-.1.3-.1.4v1c0 .2 0 .3.1.4.1.2.3.3.6.3h3.2v10.5c0 .3.1.5.3.7.1.1.3.1.5.1h1.1c.2 0 .4 0 .6-.1.3-.2.3-.5.3-.6V6.1h3.3c.3 0 .5-.1.6-.3.1-.1.1-.3.1-.4v-1c0-.2 0-.3-.1-.4-.3-.2-.5-.3-.7-.3M55 3.7h-.6c-.4 0-.7.1-.9.3-.2.1-.3.4-.5.7l-4.1 6.9L48 13V4.3c0-.3-.1-.5-.3-.6-.1-.1-.3-.1-.5-.1H46c-.2 0-.3 0-.4.1-.2.1-.3.3-.3.6V16c0 .4.1.8.3 1 .2.3.6.4 1.1.4h.6c.4 0 .7-.1.9-.3.2-.2.3-.4.5-.7l4-6.8 1-1.7v8.7c0 .1 0 .4.3.6.1.1.3.1.5.1h1.2c.2 0 .3 0 .4-.1.2-.1.3-.3.3-.6V5.1c0-.4-.1-.8-.3-1-.2-.3-.6-.4-1.1-.4M68.1 14.9c0-.1-.1-.2-.3-.3-.2-.1-.4-.2-.7 0-.4.2-.8.3-1.3.4-.4.1-.9.2-1.4.2-.7 0-1.3-.1-1.8-.3-.4-.2-.8-.5-1.1-.9-.3-.4-.5-.9-.6-1.4-.1-.5-.2-1.1-.2-1.7 0-.6.1-1.2.2-1.8.1-.6.4-1.1.6-1.5.3-.4.6-.8 1.1-1 .4-.3.9-.4 1.6-.4.5 0 .9 0 1.3.1s.8.2 1.2.4c.1.1.2.1.3.1h.2l.1-.1.3-.3.5-.9c.1-.1.2-.4.1-.7-.1-.1-.2-.3-.3-.3-.7-.3-1.3-.6-1.9-.7-1.6-.3-3-.2-4.2.4-.8.4-1.4.9-2 1.5-.5.6-.9 1.4-1.2 2.3-.4.7-.6 1.7-.6 2.8 0 1.2.1 2.2.4 3 .3.9.7 1.6 1.2 2.2.5.6 1.2 1 1.9 1.3.7.3 1.6.4 2.5.4.6 0 1.3-.1 2.1-.2s1.5-.4 2.1-.8l.3-.3c.1-.2 0-.5-.1-.7l-.3-.8zM79 5.9c.1-.1.1-.3.1-.4v-1c0-.2 0-.3-.1-.4-.1-.2-.3-.3-.6-.3h-9.2c-.3 0-.5.1-.6.3-.1.1-.1.3-.1.4v1c0 .2 0 .3.1.4.1.2.3.3.6.3h3.2v10.5c0 .3.1.5.3.7.1.1.3.1.5.1h1.1c.2 0 .4 0 .6-.1.3-.2.3-.5.3-.6V6.1h3.2c.2 0 .4 0 .6-.2M85.8 4.7c-.1-.4-.3-.7-.5-.8-.2-.2-.5-.3-1-.3h-.6c-.4 0-.7.1-.9.3-.2.2-.4.4-.5.8l-4.1 11.8c-.1.2-.1.4 0 .6.1.1.2.3.6.3h1.4c.2 0 .4-.1.5-.2.1-.1.2-.2.3-.4l.8-2.4h4.5l.8 2.4c.1.3.2.4.4.5.1 0 .3.1.4.1h1.4c.4 0 .5-.2.6-.3.1-.1.1-.3 0-.6L85.8 4.7zm-.3 7.4h-2.9L84 7.4l1.5 4.7zM99.1 3.7h-9.2c-.3 0-.5.1-.6.3-.1.1-.1.3-.1.4v1c0 .2 0 .3.1.5s.3.2.6.2h3.2v10.5c0 .3.1.5.3.7.1.1.3.1.5.1H95c.2 0 .4 0 .6-.1.3-.2.3-.5.3-.6V6.1h3.2c.3 0 .5-.1.6-.3.1-.2.1-.3.1-.4v-1c0-.1 0-.3-.1-.4-.2-.2-.4-.3-.6-.3M110.3 3.7h-.6c-.4 0-.7.1-.9.3-.2.1-.3.4-.5.7l-4.1 6.9-.9 1.5V4.3c0-.1 0-.4-.3-.6-.1-.1-.3-.1-.5-.1h-1.2c-.2 0-.3 0-.4.1-.2.1-.3.3-.3.6V16c0 .4.1.8.3 1 .2.3.6.4 1.1.4h.6c.4 0 .7-.1.9-.3.2-.1.3-.4.5-.7l4-6.8 1-1.7v8.7c0 .1 0 .4.3.6.1.1.3.1.5.1h1.2c.2 0 .3 0 .4-.1.2-.1.3-.3.3-.6V5.1c0-.4-.1-.8-.3-1-.2-.3-.6-.4-1.1-.4M124.3 3.8c-.1-.1-.3-.1-.6-.1h-1.1c-.2 0-.4 0-.5.1-.2.1-.3.3-.3.7V9h-5.5V4.5c0-.1 0-.5-.3-.6-.1-.1-.3-.1-.6-.1h-1.1c-.2 0-.4 0-.5.1-.2.1-.3.3-.3.7v12.2c0 .3.1.5.3.7.1.1.3.1.5.1h1.1c.2 0 .4 0 .6-.1.3-.2.3-.5.3-.6v-5.2h5.5v5.2c0 .3.1.5.3.7.1.1.3.1.5.1h1.1c.2 0 .4 0 .6-.1.3-.2.3-.5.3-.6V4.5c0-.2 0-.5-.3-.7" clip-path="url(#b)" fill="#3863ae"/></svg>'};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.6 30.4"><defs><path id="a" d="M0 0h17.6v30.4H0z"/></defs><path class="st0" d="M16.7 29.4c-1.5 1.6-3.2.1-4.4-1-1-1-2.3-2.2-3.3-3.1-2.8 2.9-5.1 6.5-7.4 4.5-2.7-2.3 2.6-5.8 4-7.8-1.3-.3-3.6-1-4.7-1.8s-1.3-2.7 0-3.7c1.6-1.1 2.6.1 4.5.7 7.1 2.3 9.8-4.1 11.9-.4 1.8 3.2-4.3 4.6-5 5.1 2.9 2.8 6.6 5.3 4.4 7.5"/><path class="st0" d="M9.7.1C5.9-.5 1.3 1.8.6 6.5-1 16.8 14.7 19.3 16.1 8.9 16.7 5 14.2.9 9.7.1M8.5 11c-4.3 0-4.6-6.1-.3-6.4 4.5-.3 4.5 6.3.3 6.4"/></svg>'};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612 501.6"><path class="st0" d="M612 58.8c-22.5 10-46.7 16.7-72.1 19.8 25.9-15.5 45.8-40.2 55.2-69.4-24.3 14.4-51.2 24.8-79.8 30.5C492.4 15.2 459.8 0 423.7 0c-69.3 0-125.6 56.2-125.6 125.5 0 9.8 1.1 19.4 3.3 28.6-104.3-5.2-196.8-55.2-258.8-131.2C31.8 41.5 25.7 63 25.7 86c0 43.6 22.2 82 55.8 104.5-20.6-.7-39.9-6.3-56.9-15.8v1.6c0 60.8 43.3 111.6 100.7 123.1-10.5 2.8-21.6 4.4-33.1 4.4-8.1 0-15.9-.8-23.6-2.3 16 49.9 62.3 86.2 117.3 87.2C143 422.4 88.8 442.4 30 442.4c-10.1 0-20.1-.6-29.9-1.7 55.6 35.7 121.5 56.5 192.4 56.5 230.9 0 357.2-191.3 357.2-357.2l-.4-16.3c24.6-17.6 45.9-39.7 62.7-64.9z"/></svg>'};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 548.4 312.9"><path d="M545.5 282.5c-.7-1.4-1.3-2.6-1.9-3.6-9.5-17.1-27.7-38.2-54.5-63.1l-.6-.6-.3-.3-.3-.3h-.3c-12.2-11.6-19.9-19.4-23.1-23.4-5.9-7.6-7.2-15.3-4-23.1 2.3-5.9 10.9-18.4 25.7-37.4 7.8-10.1 14-18.2 18.6-24.3 32.9-43.8 47.2-71.8 42.8-83.9l-1.7-2.8c-1.1-1.7-4.1-3.3-8.8-4.7-4.8-1.4-10.9-1.7-18.3-.7l-82.2.6c-1.3-.5-3.2-.4-5.7.1-2.5.6-3.7.9-3.7.9l-1.4.7-1.1.9c-1 .6-2 1.6-3.1 3s-2.1 3.1-2.8 5c-9 23-19.1 44.4-30.6 64.2-7 11.8-13.5 22-19.4 30.7-5.9 8.7-10.8 15-14.8 19.1-4 4.1-7.6 7.4-10.9 9.8-3.2 2.5-5.7 3.5-7.4 3.1-1.7-.4-3.3-.8-4.9-1.1-2.7-1.7-4.8-4-6.4-7-1.6-3-2.7-6.7-3.3-11.1-.6-4.5-.9-8.3-1-11.6-.1-3.2 0-7.8.1-13.7.2-5.9.3-9.9.3-12 0-7.2.1-15.1.4-23.6.3-8.5.5-15.2.7-20.1.2-4.9.3-10.2.3-15.7s-.3-9.8-1-13c-.7-3.1-1.7-6.2-3-9.1-1.3-2.9-3.3-5.2-5.9-6.9-2.6-1.6-5.8-2.9-9.6-3.9-10.1-2.3-22.9-3.5-38.5-3.7-35.4-.4-58.1 1.9-68.2 6.9-4 2.1-7.6 4.9-10.8 8.6-3.4 4.2-3.9 6.5-1.4 6.9 11.4 1.7 19.5 5.8 24.3 12.3l1.7 3.4c1.3 2.5 2.7 6.9 4 13.1 1.3 6.3 2.2 13.2 2.6 20.8.9 13.9.9 25.8 0 35.7-1 9.9-1.9 17.6-2.7 23.1-.9 5.5-2.1 10-3.9 13.4-1.7 3.4-2.9 5.5-3.4 6.3-.6.8-1 1.2-1.4 1.4-2.5.9-5 1.4-7.7 1.4s-5.9-1.3-9.7-4c-3.8-2.7-7.8-6.3-11.8-11-4.1-4.7-8.7-11.2-13.9-19.6-5.1-8.4-10.5-18.3-16-29.7l-4.6-8.3c-2.9-5.3-6.8-13.1-11.7-23.3-5-10.2-9.3-20-13.1-29.6-1.5-4-3.8-7-6.9-9.1l-1.4-.9c-.9-.8-2.5-1.6-4.6-2.4-2.1-.9-4.3-1.5-6.6-1.9l-78.2.6c-8 0-13.4 1.8-16.3 5.4l-1.1 1.7C.3 22.4 0 23.9 0 26c0 2.1.6 4.7 1.7 7.7C13.1 60.6 25.6 86.4 39 111.4s25.1 45 35 60.2c9.9 15.2 20 29.6 30.3 43.1s17.1 22.2 20.4 26c3.3 3.8 6 6.7 7.9 8.6l7.1 6.9c4.6 4.6 11.3 10 20.1 16.4 8.9 6.4 18.7 12.7 29.4 18.9 10.8 6.2 23.3 11.2 37.5 15.1 14.3 3.9 28.2 5.5 41.7 4.7h32.8c6.7-.6 11.7-2.7 15.1-6.3l1.1-1.4c.8-1.1 1.5-2.9 2.1-5.3.7-2.4 1-5 1-7.9-.2-8.2.4-15.6 1.9-22.1 1.4-6.6 3-11.5 4.9-14.8 1.8-3.3 3.9-6.1 6.1-8.4 2.3-2.3 3.9-3.7 4.9-4.1.9-.5 1.7-.8 2.3-1 4.6-1.5 9.9 0 16.1 4.4 6.2 4.5 12 10 17.4 16.6 5.4 6.6 11.9 13.9 19.6 22.1 7.6 8.2 14.3 14.3 20 18.3l5.7 3.4c3.8 2.3 8.8 4.4 14.9 6.3 6.1 1.9 11.4 2.4 16 1.4l73.1-1.1c7.2 0 12.9-1.2 16.8-3.6 4-2.4 6.4-5 7.1-7.9.8-2.9.8-6.1.1-9.7-.6-3.7-1.3-6.2-1.9-7.7z"/></svg>'};

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Index__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_TestStart__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_TestStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_TestStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_TestMain__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_TestMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_TestMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Result__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_Result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Recipes__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Recipes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_Recipes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_RecipesTest__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_RecipesTest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_RecipesTest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_RecipeItem__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_RecipeItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_RecipeItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_About__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_About__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'active',

    routes: [
    // {
    //     path: '/',
    //     name: 'Index',
    //     component: Index
    // },
    {
        path: '/',
        name: 'TestStart',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages_TestStart___default.a
    }, {
        path: '/test',
        name: 'TestMain',
        component: __WEBPACK_IMPORTED_MODULE_4__components_pages_TestMain___default.a
    }, {
        path: '/result',
        name: 'Result',
        component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Result___default.a
    }, {
        path: '/about',
        name: 'About',
        component: __WEBPACK_IMPORTED_MODULE_9__components_pages_About___default.a
    }, {
        path: '/recipes',
        name: 'Recipes',
        component: __WEBPACK_IMPORTED_MODULE_6__components_pages_Recipes___default.a
    }, {
        path: '/recipes/:id',
        name: 'Recipe',
        component: __WEBPACK_IMPORTED_MODULE_8__components_pages_RecipeItem___default.a
    }, {
        path: '/test-recipes',
        name: 'RecipesTest',
        component: __WEBPACK_IMPORTED_MODULE_7__components_pages_RecipesTest___default.a
    }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(48);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__
});

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(95),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Resize__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Menu__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Header__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_MainNav__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_MainNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_MainNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Footer__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_logo_svg__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_svg_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_spiral_svg__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_spiral_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_svg_spiral_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_svg_disc_svg__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_svg_disc_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_svg_disc_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_svg_legal_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_svg_legal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_svg_legal_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',

    data: function data() {
        return {
            pageIndex: 0,
            canHandle: true,
            mobile: false,
            mobMenuShow: false
        };
    },


    components: {
        Logo: __WEBPACK_IMPORTED_MODULE_6__assets_svg_logo_svg___default.a,
        Resize: __WEBPACK_IMPORTED_MODULE_1__components_common_Resize___default.a,
        Spiral: __WEBPACK_IMPORTED_MODULE_7__assets_svg_spiral_svg___default.a,
        Disc: __WEBPACK_IMPORTED_MODULE_8__assets_svg_disc_svg___default.a,
        DiscD: __WEBPACK_IMPORTED_MODULE_9__assets_svg_legal_svg___default.a,
        'menu-app': __WEBPACK_IMPORTED_MODULE_2__components_common_Menu___default.a,
        'header-app': __WEBPACK_IMPORTED_MODULE_3__components_parts_Header___default.a,
        'footer-app': __WEBPACK_IMPORTED_MODULE_5__components_parts_Footer___default.a,
        'main-nav': __WEBPACK_IMPORTED_MODULE_4__components_common_MainNav___default.a
    },
    mounted: function mounted() {
        var self = this;

        self.isMobile();
        window.addEventListener('resize', function () {
            self.isMobile();
        });

        ga('send', 'event', 'load', 'show', 'Home page loaded');

        //            var lay1 = document.querySelector('.layer__1');
        //            var lay2 = document.querySelector('.layer__2');
        //            document.body.addEventListener('mousemove',function(e){
        //                lay1.style.transform = 'rotate('+e.clientX/1000+'deg)';
        //                lay2.style.transform = 'rotate('+e.clientY/1000+'deg)';
        //            })
    },

    computed: {
        isHidden: function isHidden() {
            var self = this;
            switch (this.$route.name) {
                case 'Recipes':
                    return true;
                case 'Recipe':
                    return true;
                default:
                    return false;
            }
        },
        isStrong: function isStrong() {
            var self = this;
            switch (this.$route.name) {
                case 'TestStart':
                    return true;
                case 'TestMain':
                    return true;
                default:
                    return false;
            }
        },
        isAbout: function isAbout() {
            var self = this;
            switch (this.$route.name) {
                case 'About':
                    return true;
            }
        }
    },
    methods: {
        isMobile: function isMobile() {
            var classList = document.body.classList;
            var mClassName = 'mobile';
            var self = this;

            if (__WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */].isMobile()) {
                classList.add(mClassName);
                self.mobile = true;
            } else {
                classList.remove(mClassName);
                self.mobile = false;
            }
        },


        is_touch_device: function is_touch_device() {
            var isMobile = false; //initiate as false
            // device detection
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
            return isMobile;
        },

        mobMenuToggle: function mobMenuToggle(event) {
            var self = this;
            self.mobMenuShow = !self.mobMenuShow;
            if (event.currentTarget.classList.contains('mobile-menu-btn') && self.mobMenuShow == true) {
                ga('send', 'event', 'click', 'show', 'Mobile Menu Show');
            }
            if (event.currentTarget.classList.contains('menu-link')) {
                ga('send', 'event', 'click', 'show', 'Go from mobile menu to: ' + event.currentTarget.getAttribute('href'));
            }
            return self.mobMenuShow;
        }

    }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_share_svg__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_share_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_share_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _links = {
    'Index': [{ path: '/', name: '' }, { path: '/', name: '' }],
    'TestStart': [{ path: '/recipes', name: 'Рецепты' }, { path: '/about', name: 'О продукте'

        //            {path: '/',name:''},
        //            {path: '/',name:''}
    }],
    'TestMain': [{ path: '/recipes', name: 'Рецепты' }, { path: '/about', name: 'О продукте' }],
    'Result': [{ path: '/recipes', name: 'Рецепты' }, { path: '/about', name: 'О продукте' }],
    'Recipes': [{ path: '/about', name: 'О продукте' }, { path: '/', name: 'Наш тест' }],
    'Recipe': [{ path: '/about', name: 'О продукте' }, { path: '/', name: 'Наш тест' }],
    'About': [{ path: '/', name: 'Наш тест' }, { path: '/recipes', name: 'Рецепты' }],

    ///
    'RecipesTest': [{ path: '/about', name: 'О продукте' }, { path: '/', name: 'Наш тест' }]
};











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MainNav',
    computed: {
        links: function links() {
            //                console.log(this.$route.name);
            return this.$route.name in _links ? _links[this.$route.name] : false;
        }
    },

    //        props: ['mobMenuShow', 'mobMenuToggle', 'mobile'],

    props: {
        mobMenuShow: {},
        mobMenuToggle: {},
        mobile: {}
    },
    watch: {
        '$route': function $route() {
            this.turnNavMenu();
        }
    },
    methods: {
        shareOk: function shareOk() {
            __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__["a" /* default */].shareOk();
            ga('send', 'event', 'redirect', 'show', 'Odnoklassniki share click');
        },
        turnNavMenu: function turnNavMenu() {
            var self = this;
            console.log(self.$route.name);
            switch (self.$route.name) {
                case 'TestStart':
                    self.animTurn = '';
                    self.bottomNav.link = '';
                    self.bottomNav.text = '';
                    self.testNavLink = '/';
                    break;
                case 'Recipes':
                    self.animTurn = 'turn-r';
                    self.bottomNav.link = '/about';
                    self.bottomNav.text = 'О продукте';
                    self.testNavLink = '/';
                    break;
                case 'Recipe':
                    self.animTurn = 'turn-r';
                    self.bottomNav.link = '/about';
                    self.bottomNav.text = 'О продукте';
                    self.testNavLink = '/';
                    break;
                case 'About':
                    self.animTurn = 'turn-l';
                    self.bottomNav.link = '/recipes';
                    self.bottomNav.text = 'Рецепты';
                    self.testNavLink = '/';
                    break;

                case 'TestMain':
                    self.animTurn = '';
                    self.bottomNav.link = '';
                    self.bottomNav.text = '';
                    self.testNavLink = '/test';
            }
        },
        showSharing: function showSharing() {
            var self = this;
            self.show = !self.show;
            if (self.show == true) {
                ga('send', 'event', 'click', 'show', 'Show Sharing');
            }
        },
        gaNav: function gaNav(event) {
            ga('send', 'event', 'click', 'show', 'Click Nav Button To: ' + this.$route.path);
        }
    },
    components: {
        Arrow: __WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg___default.a,
        Share: __WEBPACK_IMPORTED_MODULE_1__assets_svg_share_svg___default.a,
        Twitter: __WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg___default.a,
        FB: __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg___default.a,
        VK: __WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg___default.a,
        OK: __WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg___default.a,
        socialSharing: __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing___default.a
    },

    data: function data() {
        return {
            show: false,
            animTurn: '',
            bottomNav: {
                link: '',
                text: ''
            },
            testNavLink: ''
        };
    },
    mounted: function mounted() {
        this.turnNavMenu();
    }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Menu'
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Recipes',
    props: ['recipe', 'index'],
    methods: {
        gaRecipe: function gaRecipe() {
            ga('send', 'event', 'click', 'show', 'Recipe Name: ' + this.recipe.title);
        }
    }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


var defaultWidth = 1280,
    defaultFont = 16,
    minWidth = 768,
    minHeight = 600,
    defaultHeight = 728;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Resize',
    props: ['mobile', 'mobMenuShow'],
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize.bind(this));
        return this.mobMenuShow;
    },
    data: function data() {
        return {
            vW: window.innerWidth,
            vH: window.innerHeight
        };
    },

    computed: {
        fSize: function fSize() {
            if (this.mobile) {
                return 16;
            }
            if (this.vW < 1500) {
                return 16 * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight) + 1;
            }
            return 16 * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
        }
    },
    methods: {
        onResize: function onResize() {
            this.vW = window.innerWidth;
            this.vH = window.innerHeight;
        }
    }

});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_item_1_svg__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_item_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_item_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_item_2_svg__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_item_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_item_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_item_3_svg__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_item_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_item_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_item_4_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_item_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_item_4_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'About',
    data: function data() {
        return {
            angle: 0
        };
    },
    mounted: function mounted() {
        var self = this;
        document.body.addEventListener('mousemove', function (e) {
            self.angle = (e.clientX + e.clientY) / 1000;
        });
    },

    components: {
        Arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg___default.a,
        Item1: __WEBPACK_IMPORTED_MODULE_2__assets_svg_item_1_svg___default.a,
        Item2: __WEBPACK_IMPORTED_MODULE_3__assets_svg_item_2_svg___default.a,
        Item3: __WEBPACK_IMPORTED_MODULE_4__assets_svg_item_3_svg___default.a,
        Item4: __WEBPACK_IMPORTED_MODULE_5__assets_svg_item_4_svg___default.a
    },
    methods: {
        gaMore: function gaMore() {
            ga('send', 'event', 'redirect', 'show', 'About Page Redirect');
        }
    }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Page1',
    methods: {
        gaClickNext: function gaClickNext() {
            ga('send', 'event', 'click', 'show', 'Home page click Next');
        }
    },
    data: function data() {
        return {
            angle: 0
        };
    },
    mounted: function mounted() {
        var self = this;
        document.body.addEventListener('mousemove', function (e) {
            self.angle = (e.clientX + e.clientY) / 1000;
        });
    }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Recipe__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Recipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Recipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_storage__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_Helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'RecipeItem',

    props: ['recipe', 'index'],

    mounted: function mounted() {
        document.body.scrollTop = 0;

        function hideTitle() {

            if (__WEBPACK_IMPORTED_MODULE_4__tools_Helpers__["a" /* default */].isMobile()) {
                return;
            }

            var scrolled = window.pageYOffset || document.documentElement.scrollTop;
            if (scrolled > 0) {
                document.querySelector('.menu-btn.left').classList.add('hide');
            } else {
                document.querySelector('.menu-btn.left').classList.remove('hide');
            }
        };

        window.onscroll = function () {
            hideTitle();
        };
    },


    methods: {
        scrollTop: function scrollTop() {
            document.body.scrollTop = 0;
        },
        gaBack: function gaBack() {
            ga('send', 'event', 'click', 'show', 'Click Back button');
        }
    },
    data: function data() {
        return {
            id: this.$route.params.id,
            RecipeItem: this.$store.state.RecipeDate[this.$route.params.id]
        };
    },
    created: function created() {
        //            console.log(this.$route.params.slug);
        //            this.recipe = this.Recipes[0];

    },

    components: {
        Arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg___default.a
    }

});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Recipe__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Recipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Recipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_storage__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_svg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_Helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Recipes',

    props: ['recipe', 'index'],

    data: function data() {
        return {
            type: 'all'
        };
    },
    mounted: function mounted() {
        if (this.$route.path == '/recipes') {
            var hideTitle = function hideTitle() {
                if (__WEBPACK_IMPORTED_MODULE_4__tools_Helpers__["a" /* default */].isMobile()) {
                    return;
                }
                var scrolled = window.pageYOffset || document.documentElement.scrollTop;
                if (scrolled > 0) {
                    document.querySelector('.menu-btn.left').classList.add('hide');
                } else {
                    document.querySelector('.menu-btn.left').classList.remove('hide');
                }
            };

            ;

            window.onscroll = function () {
                hideTitle();
            };
        }
    },

    methods: {
        toggleType: function toggleType(type) {
            this.type = type;
            ga('send', 'event', 'click', 'show', 'Tab click: ' + this.type);
        },
        up: function up() {
            var t;
            var e = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
            return e > 0 ? (window.scrollBy(0, (e + 100) / -10), t = setTimeout(this.up, 20)) : clearTimeout(t), !1;
        },
        gaUp: function gaUp() {
            ga('send', 'event', 'click', 'show', 'Click to Up');
        }
    },
    computed: {
        recipes: function recipes() {
            var self = this;
            return __WEBPACK_IMPORTED_MODULE_2__store_storage__["a" /* default */].filter(function (rec, index) {
                return rec.type == self.type || self.type == 'all';
            });
        }
    },
    components: {
        Recipe: __WEBPACK_IMPORTED_MODULE_1__components_common_Recipe___default.a,
        Arrow: __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_svg___default.a
    }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Recipe__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Recipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Recipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_storage__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_TestMain__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_TestMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_TestMain__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Recipes',

    props: ['recipe', 'index', 'bal'],

    data: function data() {
        return {
            type: 'all',

            //                id: this.$route.params.id,
            RecipeItem: this.$store.state.RecipeDate
        };
    },
    mounted: function mounted() {
        var self = this;

        console.log(this.$store.state.RecipeDate);
    },

    methods: {},

    computed: {
        //            recipes(){
        //                let self = this;
        //                console.log(this);
        //            }
    },

    components: {
        Recipe: __WEBPACK_IMPORTED_MODULE_1__components_common_Recipe___default.a,
        TestMain: __WEBPACK_IMPORTED_MODULE_3__components_pages_TestMain___default.a
    }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Result',
    components: {
        Arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg___default.a
    }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_storage__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Test',
    data: function data() {
        return {
            bal: 0,
            testNum: 1,
            showRecipes: false,
            RecipeItem: this.$store.state.RecipeDate
        };
    },


    watch: {
        'testNum': function testNum() {
            if (this.testNum > 5) {
                ga('send', 'event', 'load', 'show', 'Test results loaded');
            }
        }
    },

    mounted: function mounted() {

        function hideTitle() {

            if (__WEBPACK_IMPORTED_MODULE_7__tools_Helpers__["a" /* default */].isMobile()) {
                return;
            }

            var scrolled = window.pageYOffset || document.documentElement.scrollTop;
            if (scrolled > 0) {
                document.querySelector('.menu-btn.top').classList.add('hide');
            } else {
                document.querySelector('.menu-btn.top').classList.remove('hide');
            }
        };

        window.onscroll = function () {
            hideTitle();
        };
    },

    components: {
        Arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_long_svg___default.a,
        Twitter: __WEBPACK_IMPORTED_MODULE_2__assets_svg_twitter_svg___default.a,
        FB: __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg___default.a,
        VK: __WEBPACK_IMPORTED_MODULE_5__assets_svg_vk_svg___default.a,
        OK: __WEBPACK_IMPORTED_MODULE_4__assets_svg_ok_svg___default.a,
        Storage: __WEBPACK_IMPORTED_MODULE_8__store_storage__["a" /* default */],
        socialSharing: __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing___default.a
    },
    methods: {
        selectAnswer: function selectAnswer(bal) {
            this.bal = this.bal + bal;
            this.testNum++;
        },
        recShow: function recShow() {
            this.showRecipes = true;
            ga('send', 'event', 'click', 'show', 'Test result click Next');
        },
        gaRedirect: function gaRedirect() {
            ga('send', 'event', 'redirect', 'show', 'Test result Redirect');
        },
        gaMore: function gaMore() {
            ga('send', 'event', 'redirect', 'show', 'Test result click More');
        },
        shareOk: function shareOk() {
            __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__["a" /* default */].shareOk();
            ga('send', 'event', 'redirect', 'show', 'Odnoklassniki share click');
        }
    }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_item_5_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_item_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_item_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_item_6_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_item_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_item_6_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Test',
    components: {
        Item1: __WEBPACK_IMPORTED_MODULE_1__assets_svg_item_5_svg___default.a,
        Item2: __WEBPACK_IMPORTED_MODULE_2__assets_svg_item_6_svg___default.a
    },
    data: function data() {
        return {
            angle: 0
        };
    },

    methods: {
        gaClickStart: function gaClickStart() {
            ga('send', 'event', 'click', 'show', 'Test page click Start');
        }
    },
    mounted: function mounted() {
        var self = this;
        document.body.addEventListener('mousemove', function (e) {
            self.angle = (e.clientX + e.clientY) / 1000;
        });
    }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Footer'
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Header',
    components: {
        LogoLeft: __WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg___default.a,
        Arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg___default.a
    },
    methods: {
        gaLogoClick: function gaLogoClick() {
            ga('send', 'event', 'redirect', 'show', 'Redirect from Logo to: ' + event.currentTarget.getAttribute('href'));
        }
    }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_app_scss__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_scss_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_social_sharing__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  created: function created() {
    this.$on('social_shares_close', function (network, url) {
      ga('send', 'event', 'click', 'show', 'Click social: ' + network);
    });
  },

  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_social_sharing___default.a);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentId", function() { return getCurrentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bal", function() { return Bal; });


var getCurrentId = function getCurrentId(state) {
  return state.currentId;
};
var Bal = function Bal(state) {
  return state.bal;
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ID", function() { return UPDATE_ID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(14);


var UPDATE_ID = function UPDATE_ID(State, id) {
    State.currentId = parseInt(id);
};

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(105),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(97),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46058350",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(101),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(109),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(106),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(100),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(103),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(107),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(104),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    staticClass: "app-layout",
    class: {
      about: _vm.isAbout
    },
    attrs: {
      "id": "app",
      "mobile": _vm.mobile,
      "mobMenuShow": _vm.mobMenuShow
    }
  }, [_c('header-app'), _vm._v(" "), _c('div', {
    staticClass: "background-container"
  }, [_c('div', {
    staticClass: "bg-center valign"
  }, [_c('Spiral')], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-bottom",
    class: {
      hide: _vm.isHidden, strong: _vm.isStrong
    }
  }, [_c('p', {
    staticClass: "mobile-hidden"
  }, [_vm._v("* Шендеров Б.А. Метабиотики: новая идея или естественное развитие пробиотической концепции:\n                Материалы симпозиума «Современное состояние и перспективы развития концепции пробиотикотерапии».")]), _vm._v(" "), _c('p', {
    class: {
      hidden: !_vm.isAbout
    }
  }, [_vm._v("** Инструкция по применению БАКТИСТАТИН®")]), _vm._v(" "), _c('p', [_vm._v("Москва, 30.09.2013.  СГР № RU.77.99.88.003. E.010166.11.14 от 05.11.2014 г. ")]), _vm._v(" "), _c('p', [_vm._v("АО «НИЖФАРМ» 119017, Москва, ул. Большая Ордынка, 44с4")]), _vm._v(" "), _c('DiscD', {
    staticClass: "mobile-hidden"
  }), _vm._v(" "), _c('Disc', {
    staticClass: "desktop-hidden"
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fades"
    }
  }, [(!_vm.mobMenuShow) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), _c('main-nav', {
    attrs: {
      "mobMenuShow": _vm.mobMenuShow,
      "mobMenuToggle": _vm.mobMenuToggle,
      "mobile": _vm.mobile
    }
  }), _vm._v(" "), (_vm.mobile) ? _c('div', {
    staticClass: "rotate-message valign desktop-hidden"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/rotate.png",
      "alt": "Rotate"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Пожалуйста, переверните устройство")])]) : _vm._e(), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.showRecipes) ? _c('section', [_c('h3', {
    staticClass: "section-title section-title__test"
  }, [_vm._v("Тест")]), _vm._v(" "), (this.testNum <= 5) ? _c('div', {
    staticClass: "test-container valign"
  }, [_vm._m(0), _vm._v(" "), (this.testNum == 1) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "1"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Ананас на гриле")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Говяжьи шашлычки")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 2) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "2"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Порей с чесночным майонезом")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Ягненок тандури")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 3) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "3"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Персики на гриле с горгонзолой и медом")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Сэндвич с яичницей")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 4) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "4"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Дорада на гриле с мандаринами и майораном")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Шаверма в пите")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 5) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "5"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Зажаренная на гриле капуста")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Цыпленок гриль с орегано")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "test-progress"
  }, [_c('span', {
    class: [this.testNum === 1 ? 'active' : '', '', this.testNum > 1 ? 'done' : '', '']
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 2 ? 'active' : '', '', this.testNum > 2 ? 'done' : '', '']
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 3 ? 'active' : '', '', this.testNum > 3 ? 'done' : '', '']
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 4 ? 'active' : '', '', this.testNum > 4 ? 'done' : '', '']
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 5 ? 'active' : '', '']
  }, [_vm._v("5")])])]) : _vm._e(), _vm._v(" "), (this.testNum > 5 && this.bal > 30) ? [_c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Будьте внимательнее!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    attrs: {
      "url": "http://baktistatin.eda.ru/share-1.html"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_vm._m(2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Позаботьтесь об этом заранее – храните БАКТИСТАТИН ® при себе!")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "image-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.recShow($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])])] : _vm._e(), _vm._v(" "), (this.testNum > 5 && this.bal > 10 && this.bal <= 30) ? [_c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Неплохой результат!")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    attrs: {
      "url": "http://baktistatin.eda.ru/share-2.html"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_vm._m(4)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Поэтому, возьмите с собой на выходные упаковку препарата БАКТИСТАТИН ®.")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "image-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.recShow($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])])] : _vm._e(), _vm._v(" "), (this.testNum > 5 && this.bal <= 10) ? [_c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Хороший результат!")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    attrs: {
      "url": "http://baktistatin.eda.ru/share-3.html"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_vm._m(6)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Лучше иметь БАКТИСТАТИН ®\n                            под рукой для себя или увлекающихся BBQ близких.")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "image-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.recShow($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showRecipes) ? _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты")]), _vm._v(" "), _vm._m(7), _vm._v(" "), (this.bal > 30) ? _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 11
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[11].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 13
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[13].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[13].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[13].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[13].time))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 17
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[17].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 18
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[18].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[18].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[18].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[18].time))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaMore($event)
      }
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)]) : _vm._e(), _vm._v(" "), (this.bal > 10 && this.bal <= 30) ? _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 3
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[3].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 8
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[8].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].time))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 11
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[11].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 17
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[17].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].time))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaMore($event)
      }
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)]) : _vm._e(), _vm._v(" "), (this.bal <= 10) ? _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[1].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[1].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[1].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[1].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 2
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[2].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[2].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[2].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[2].time))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 3
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[3].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 8
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[8].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].time))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaMore($event)
      }
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-container text-container__test"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                        Из нескольких пар блюд, приготовленных на гриле, выберите те, которые вам больше нравятся.\n                        По результатам теста мы расскажем, как часто вы можете устраивать и посещать BBQ-мероприятия без последствий для вашего организма.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                            Судя по вашим кулинарным предпочтениям, вашему кишечнику понадобится помощь уже на второй день выходных.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Ok"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                            Похоже, что ваше меню на выходные находится в разумном балансе между сытостью и полезностью. Однако не стоит забывать, что и при таком режиме ваш кишечник может перетрудиться.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Ok"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                            Вы сможете провести почти месяц BBQ сезона без последствий для кишечника. Однако, потом вам все равно потребуется период восстановления.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Ok"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-container text-container-relative"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Мы подобрали рецепты на твой вкус:")])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("На главную")]), _vm._v(" /\n    "), _c('router-link', {
    attrs: {
      "to": "/page2"
    }
  }, [_vm._v("На внутреннюю")])], 1)
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.recipe.id
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaRecipe($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.recipe.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num"
  }, [_vm._v(_vm._s(_vm.index + 1))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.recipe.title))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.recipe.portion) + " порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.recipe.time) + " минут")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты " + _vm._s(_vm.id))]), _vm._v(" "), _c('div', {
    staticClass: "recipes-wrap recipes-wrap__single"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn-back",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaBack($event)
      }
    }
  }, [_c('Arrow'), _vm._v("Вернуться")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem.name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem.portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem.time))])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.RecipeItem.image,
      "alt": "Recipe Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recipe-block"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n                    Ингридиенты:\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.RecipeItem.ingredients), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "name left"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
      staticClass: "value right"
    }, [_vm._v(_vm._s(item.value))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "recipe-block"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n                    Инструкция приготовления:\n                ")]), _vm._v(" "), _c('ol', {
    staticClass: "instruction"
  }, _vm._l((_vm.RecipeItem.instruction), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.text))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn-back mobile-hidden",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaBack($event)
      }
    }
  }, [_c('Arrow'), _vm._v("Вернуться")], 1), _vm._v(" "), _c('a', {
    staticClass: "btn-top desktop-hidden",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTop($event)
      }
    }
  }, [_c('span', [_vm._v("В начало")]), _c('Arrow')], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[5].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(3)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-container text-container-relative"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Мы подобрали рецепты на твой вкус:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v("Стейки с картофелем и спаржей на гриле")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v("Стейки с картофелем и спаржей на гриле")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v("Стейки с картофелем и спаржей на гриле")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])
}]}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      fontSize: _vm.fSize + 'px'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты")]), _vm._v(" "), _c('div', {
    staticClass: "text-container text-container-relative"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "recipes-btn"
  }, [_c('li', [_c('a', {
    staticClass: "btn",
    class: {
      'recipes-active': (_vm.type == 'meat')
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleType('meat')
      }
    }
  }, [_vm._v("мясо")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn",
    class: {
      'recipes-active': (_vm.type == 'no-meat')
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleType('no-meat')
      }
    }
  }, [_vm._v("без мяса")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn",
    class: {
      'recipes-active': (_vm.type == 'all')
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleType('all')
      }
    }
  }, [_vm._v("всё")])])])]), _vm._v(" "), _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, _vm._l((_vm.recipes), function(rec, index) {
    return (index % 2 == 0) ? _c('Recipe', {
      key: index,
      attrs: {
        "recipe": rec,
        "index": index
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, _vm._l((_vm.recipes), function(rec, index) {
    return (index % 2 != 0) ? _c('Recipe', {
      key: index,
      attrs: {
        "recipe": rec,
        "index": index
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('a', {
    staticClass: "btn-top",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.up($event)
      }
    }
  }, [_vm._v("в начало "), _c('Arrow')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main text-main-recipes"
  }, [_c('p', [_vm._v("Мы собрали для вас 20 лучших рецепты блюд, приготовленных на гриле. Выбери любимый рецепт или порадуй\n            близких и друзей умением готовить разнообразные и вкусные блюда на пикнике!")])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Тест")]), _vm._v(" "), _c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Лучше иметь «БАКТИСТАТИН»\n                    под рукой для себя или увлекающихся BBQ близких.")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("далее")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Неплохой результат!")]), _vm._v(" "), _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Вы сможете провести почти два месяца BBQ сезона без последствий для кишечника. Однако, потом вам все равно потребуется период восстановления.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-right"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])
}]}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('a', {
    staticClass: "logo logo__left",
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaLogoClick
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo-b2.png",
      "alt": "baktistatin"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('a', {
    staticClass: "logo logo__right",
    attrs: {
      "href": "https://eda.ru/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaLogoClick
    }
  }, [_c('span', [_vm._v("спецпроект")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/icons/eda.png",
      "alt": "Eda Logo"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-text mobile-hidden"
  }, [_c('span', [_vm._v("БАКТИСТАТИН ® представитель нового поколения пробиотиков – метабиотик* ")])])
}]}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.links !== false) ? _c('menu', {
    staticClass: "valign"
  }, [(_vm.mobile) ? [(!_vm.mobMenuShow && _vm.links[0].name != '') ? _c('router-link', {
    staticClass: "valign menu-btn menu-btn__left",
    attrs: {
      "to": _vm.links[0].path
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.links[0].name))])], 1) : _vm._e(), _vm._v(" "), (!_vm.mobMenuShow && _vm.links[0].name != '') ? _c('router-link', {
    staticClass: "valign menu-btn menu-btn__right",
    attrs: {
      "to": _vm.links[1].path
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.links[1].name))]), _vm._v(" "), _c('Arrow')], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.mobile) ? [(!_vm.mobMenuShow && _vm.links[0].name != '') ? _c('div', {
    staticClass: "anim-nav-menu"
  }, [_c('div', {
    staticClass: "anim-container"
  }, [_c('div', {
    class: 'anim-wrapper ' + _vm.animTurn
  }, [_c('router-link', {
    staticClass: "menu-btn left",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v("Рецепты")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-btn top",
    attrs: {
      "to": _vm.testNavLink
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v("Тест")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-btn right",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v("О продукте")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-btn bottom",
    attrs: {
      "to": _vm.bottomNav.link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v(_vm._s(_vm.bottomNav.text))])], 1)], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ellipse.png",
      "alt": ""
    }
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn-share",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSharing($event)
      }
    }
  }, [_c('Share')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social social-click",
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Vkontakte"
    }
  })])])], 1) : _vm._e()]), _vm._v(" "), (_vm.mobile) ? _c('a', {
    staticClass: "mobile-menu-btn desktop-hidden",
    class: {
      close: _vm.mobMenuShow
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mobMenuShow) ? _c('div', {
    staticClass: "mobile-menu-wrap desktop-hidden"
  }, [_c('div', {
    staticClass: "valign"
  }, [_c('h3', {
    staticClass: "mobile-menu-title"
  }, [_vm._v("Содержание")]), _vm._v(" "), _c('ul', {
    staticClass: "mobile-menu"
  }, [_c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_vm._v("Наш тест")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_vm._v("Рецепты")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_vm._v("О продукте")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Vkontakte"
    }
  })])])], 1)])]) : _vm._e()])], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "text-container valign"
  }, [_c('h3', {
    staticClass: "text-title__big"
  }, [_vm._v("ТЕСТ НА BBQ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaClickNext($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "decoration-container decoration-container__main"
  }, [_c('div', {
    staticClass: "layer layer__1",
    style: ({
      transform: 'rotate(-' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__2",
    style: ({
      transform: 'rotate(' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-1",
    attrs: {
      "src": "/static/images/grill.png",
      "alt": "Grill"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-2",
    attrs: {
      "src": "/static/images/item-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-3",
    attrs: {
      "src": "/static/images/item-3-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-4",
    attrs: {
      "src": "/static/images/item-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-5",
    attrs: {
      "src": "/static/images/item-4-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-6",
    attrs: {
      "src": "/static/images/item-5.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-7",
    attrs: {
      "src": "/static/images/item-6.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-8",
    attrs: {
      "src": "/static/images/item-7.png",
      "alt": "Item"
    }
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Планируете провести выходные с шампуром в руке? Ждете вечер пятницы, чтобы отправиться на дачу и жарить там стейки до воскресенья?\n            Неплохой план, однако к нему стоит подготовиться заранее, чтобы ваш организм не испытал белковую (и не только) перегрузку.\n            Узнайте о том, какие рецепты вам подойдут, а также\n            о мерах, которые стоит принять, если мяса окажется"), _c('br', {
    staticClass: "mobile-hidden"
  }), _vm._v(" слишком много.")])])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer')
},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Тест")]), _vm._v(" "), _c('div', {
    staticClass: "text-container valign"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/test"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaClickStart($event)
      }
    }
  }, [_c('span', [_vm._v("начать тест")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "decoration-container decoration-container__test"
  }, [_c('div', {
    staticClass: "layer layer__1",
    style: ({
      transform: 'rotate(' + _vm.angle / 3 + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__2",
    style: ({
      transform: 'rotate(-' + _vm.angle / 3 + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__3",
    style: ({
      transform: 'rotate(' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('Item1')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('Item2')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-5-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-7-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-4-1.png",
      "alt": "Item"
    }
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Планируете провести выходные с шампуром в руке?"), _c('br'), _vm._v("Ждете вечер пятницы, чтобы отправиться на дачу и\n                жарить там стейки до воскресенья? В нашем спецпроекте вы узнаете о том, какие рецепты вам подойдут,\n                а также о мерах, которые стоит принять, чтобы ваш организм не испытал белковую (и не только) перегрузку. ")])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("\n        О продукте\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-container text-container__about valign"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaMore
    }
  }, [_c('span', [_vm._v("узнать больше")])]), _c('Arrow')], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "decoration-container decoration-container__about"
  }, [_c('div', {
    staticClass: "layer layer__1",
    style: ({
      transform: 'rotate(' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-7-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-6-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-5-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-2-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-3-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-4.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/grill2.png",
      "alt": "Item"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__2",
    style: ({
      transform: 'rotate(-' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('Item1')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('Item2')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('Item3')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('Item4')], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Продолжаем сезон барбекю!"), _c('br'), _vm._v("И проводим его с максимальной пользой для кишечника.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_c('span', [_vm._v("БАКТИСТАТИН ®")]), _vm._v(" — комплекс дополняющих друг друга 3-х природных компонентов**:\n            "), _c('ul', [_c('li', [_vm._v("Метаболиты Bacillus subtilis (способствуют полноценному пищеварению)")]), _vm._v(" "), _c('li', [_vm._v("Природный сорбент цеолит (уменьшает различные виды интоксикации, нормализует перистальтику кишечника)")]), _vm._v(" "), _c('li', [_vm._v("Пребиотический компонент (обеспечивает благоприятные условия для роста и восстановления нормальной микрофлоры кишечника)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("Открываете сезон барбекю — не забудьте про БАКТИСТАТИН®!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-right"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])
}]}

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="624" height="119" viewBox="0 0 624 119"><image data-name="производитель ООО «Крафт», 197022, г. Санкт-Петербург, пр. Меди" width="624" height="119" xlink:href="data:img/png;base64,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"/></svg>'};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.8 40.6"><defs><path id="a" transform="rotate(-51.728 23.002 20.034)" d="M4.7-3.7h36.7v47.5H4.7z"/></defs><path class="st0" d="M34.3 5.6c4 3.1 6.3 7.6 6.9 12.3.3 2.9 0 5.8-1 8.6l2 1.6 1.1-1.1 2.3 1.8c-2.5 4.7-5.7 8.5-9.3 11.8L34 38.8c.2-.4.5-.8.7-1.2l-2.2-1.8c-2.2 1.4-4.7 2.2-7.3 2.5-4.7.6-9.5-.7-13.5-3.8-4-3.1-6.3-7.6-6.9-12.2-.3-2.6-.1-5.2.7-7.7l-2.1-1.7-1 1L0 12C2.3 7.7 5.3 3.7 9.3.2L11.6 2c-.3.5-.5.9-.8 1.4l1.8 1.4c2.5-1.7 5.3-2.7 8.1-3 4.7-.6 9.6.6 13.6 3.8M9.9 4.7c-1.6 2.5-3.5 4.8-5.5 6.9L6 12.8c.6-1.5 1.5-2.9 2.5-4.2.8-1.1 1.8-2 2.8-2.8L9.9 4.7m.3 13s-2.1 4.2 1.3 7.6c2.3 2.2 6.1 3 8.5 3.2.5 1.1 1.7 3.3 2.7 3.3l.3-2.2 1.9-.6s-.4-1.1-1.7-1.8c-.5-.3-1-.3-1.3-.4-.3-1.5-1.2-3.8-3.5-6-1.5-1.4-3.1-2.2-4.4-2.6.3 1.7-.5 3.2-2.1 4.1l-.1-.3c1.4-.7 2.3-2.9 1.5-4.1-1.8-.4-3.1-.2-3.1-.2m.8 7.4c.2.4.5.8.8 1.3.9 1.1 2.1 1.9 2.1 1.9l.6-.9c-1.2-.5-2.3-1.1-3.2-2l-.3-.3m-.3-4.2c.3.2.6.2.8-.1.2-.3.2-.6-.1-.8-.3-.2-.6-.2-.8.1s-.2.6.1.8M33.8 25s2.6-5.1-1.6-9.3c-2.8-2.7-7.5-3.6-10.4-3.9-.6-1.3-2.1-4.1-3.3-4l-.3 2.7-2.4.7s.6 1.4 2.1 2.2c.6.3 1.2.4 1.6.4.4 1.9 1.5 4.7 4.4 7.4 1.9 1.7 3.8 2.7 5.4 3.2-.4-2.1.7-3.9 2.5-5l.1.2c-1.7.8-2.8 3.5-1.9 5.1 2.2.6 3.8.3 3.8.3m-1-9.1c-.2-.5-.6-1-1-1.6-1.1-1.3-2.6-2.3-2.6-2.3l-.7 1c1.4.6 2.8 1.4 3.9 2.4.2.2.3.4.4.5m.4 5.1c-.3-.2-.8-.2-1 .1-.2.3-.2.8.1 1 .3.2.8.2 1-.1.3-.3.2-.7-.1-1m-20.5 7.8c-.6-.5-1.2-1.1-1.7-1.7l-.3-.3 1.7 4.6c.3.3.6.5.9.8l.9.6-1.5-4zM8 15.7c-.2.7-.4 1.5-.5 2.2l.9 2.5V20c0-.6.2-1.3.4-2L8 15.7zm25.8-6.9c-.4-.4-.8-.7-1.2-1.1-.2-.2-.4-.3-.6-.5l6 16.6c.2-.8.3-1.6.4-2.3L33.8 8.8zm1.7 14.5c-.1.7-.3 1.3-.6 1.9l1.1 3.1c.3-.4.5-.9.8-1.4l-1.3-3.6zM29.1 5.7c-.5-.2-1-.4-1.5-.5l2.1 5.8.1.1c.6.4 1.2.9 1.7 1.4l-2.4-6.8zM33 26.2c-.4 0-.9 0-1.3-.1l1.9 5.2c.3-.3.6-.6.9-1L33 26.2zM25.1 4.6c-.4-.1-.9-.1-1.3-.1l2.6 7.1c.5.1 1 .3 1.4.4l-2.7-7.4zm4.2 21.1l-.5-.1c-.3-.1-.7-.2-1-.4l3 8.2c.4-.2.7-.4 1-.7l-2.5-7zM21.6 4.5h-.5c-.3 0-.5.1-.8.1l2.2 6.1c.4.1.9.1 1.3.2l-2.2-6.4zM25 23.7c-.6-.4-1.2-.9-1.8-1.4l1.7 4.7c.4.4.8.9 1 1.5l.4 1.1-.5.1 1.8 5c.4-.1.8-.3 1.1-.4L25 23.7zM18.3 5.1c-.4.1-.8.3-1.1.4l.4 1.2h1.2l-.5-1.6zM24 30.6l-.3 2.2h-.2l1 2.7h.3c.3 0 .6-.1.9-.1L24 30.6zm-5.8-15.8c-.3-.1-.6-.2-.9-.4l-.6-.3 2 5.4c.2.1.3.3.5.4.6.5 1.1 1.1 1.6 1.7l-2.6-6.8zm-3-8.3c-.4.2-.7.4-1 .6l1.1 3.1 1.1-.4-1.2-3.3zm5.7 25.4c-.7-.7-1.2-1.7-1.6-2.5-.2 0-.4 0-.6-.1l2.2 6c.4.1.9.1 1.3.1l-1.3-3.5zM12.4 8.5l-.9.9 2.8 7.6h.1c.5.2 1 .3 1.4.6l-3.4-9.1zm3.9 20.4l-1.2-.3-.1.2 2 5.6c.5.2 1 .4 1.5.5l-2.2-6zM9.9 11.4c-.3.4-.5.9-.8 1.3l1.4 3.8h1.3l-1.9-5.1zm25.6 24.7c1.6-2.4 3.4-4.7 5.4-6.9L39.4 28c-.6 1.2-1.3 2.3-2.1 3.3-1 1.3-2.2 2.5-3.5 3.4l1.7 1.4M21 3.7c-4.2.5-8.1 2.6-10.9 6.1-2.8 3.5-3.9 7.9-3.4 12 .5 4.2 2.6 8.2 6.1 11s7.9 3.9 12 3.4c4.2-.5 8.1-2.6 10.9-6.1 2.8-3.5 3.9-7.9 3.4-12-.5-4.2-2.6-8.1-6.1-10.9s-7.8-3.9-12-3.5"/></svg>'};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.6 25.5"><defs><path id="a" transform="rotate(-73.566 22.5 14.212)" d="M9.2-7.5h26.6v43.4H9.2z"/></defs><path class="st0" d="M4.6 7.1c-.6 2.2 0 4.1 1.2 5.6.8 1.1 2 2 3.3 2.7 1.3.8 2.8 1.3 4.2 1.7 2.4.6 4.6.7 5.8 0 0 0 .3-.2.7-.4 3-1.7 5.7-3.2 9.2-3.7 2.1-.3 4.7 0 6.8.3.5.1 1 .1 1.6.2 1.3.1 2.3.1 3.2.1 1-.1 1.6-.3 2-.5.3-.2.4-.4.4-.6v-.2c-.1-.6-.6-1.3-1.4-2.1l-2.4 2.3c-.5-.1-1.1-.2-1.8-.2-.3 0-.6-.1-1-.1l3.5-3.3c-.8-.5-1.7-1.1-2.7-1.5l-5.1 4.7c-1.1 0-2.2 0-3.3.1l6.1-5.7c-1-.4-2.1-.7-3.2-1L22 14.2c-1.9 1.1-3.9 2.1-5.7 2.2l.4-.4L29.2 4.6c-.2 0-.3-.1-.5-.1-1.1-.3-2.1-.5-3.2-.8l-13.2 12c-.9-.2-1.7-.5-2.4-.9l13-11.6c-1.5-.3-3.1-.5-4.6-.6L7.1 12.7c-.5-.6-.9-1.2-1.2-1.9l9.3-8.5h-1.7c-.8 0-1.6.1-2.4.2L5.2 7.9c-.1-.7-.1-1.4 0-2.2-.2.2-.3.5-.4.8-.1.2-.2.4-.2.6M10.2.5h.1c.9-.1 1.9-.2 2.9-.3 3.6-.1 7.7.3 11.7 1.1l.3.1c1.4.3 2.8.6 4.1 1 2.5.6 4.8 1.4 6.9 2.1 2.3.8 4.4 2 6 3.3 1.8 1.4 2.9 2.9 3.2 4.2.1.5.1 1-.1 1.4L44 18.1l-.2.7c-.1.7-.6 1.2-1.3 1.7-.8.5-1.9.8-3.4.9-.9.1-2 0-3.3-.1-.4 0-1-.1-1.7-.2-2-.2-4.4-.5-6.2-.3-3.1.4-5.5 1.8-8.3 3.4-.1.1-.2.1-.7.4-1.7 1-4.7 1-7.8.2-1.6-.4-3.3-1.1-4.9-2-1.6-.9-3-2-4-3.4C.6 17.4-.2 14.9.5 12c0-.1 0-.2.1-.3 0-.1 0-.2.1-.2l1.5-5.2c.1-.4.3-.8.5-1.3.1-.3.3-.5.4-.7C4.5 2.2 7 1 10.2.5"/></svg>'};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.5 44.9"><defs><path id="a" transform="rotate(-71.174 18.153 22.29)" d="M-5.5 4.7h47.2v35.2H-5.5z"/></defs><path class="st0" d="M6.7 5.2c-.7 4.7.5 8.6 4.2 11.5L.1 36.1h.1l.8.3h.1L7.5 27l6.5 4.5-3.9 13h.1l.8.3h.1L16 32.1l7.8.4-.7 11.4h.1l.8.3h.1l3.2-21.9c4.8 0 8-2.4 10.4-6.5l1.1.4.6-1.6-.9-.3-2.6-.9L23.3 9l-1-.4L9.5 4.3l-2.6-.9-.8-.3-.6 1.7 1.2.4zm5.1 2.4C11.5 8 11 8.8 11 9c0 .3 3.8 1.5 4.3 1.6.4 0 .8-.8 1.3-1.3l1.1.4c-.4.5-1.4 2.3-2.4 2.2-.5-.1-2.6-.7-3.7-1.2-1-.5-1.8-1-1.8-1.5 0-.4.5-1.4.8-1.9l1.2.3zm12 23.7l-6.3-2.1-.2.8 3.8 1.3-4.6-.5 3.8-9.8c1.5.5 2.9.9 4.2 1.1l-.7 9.2zM8.2 25.9l5.2-7.6c1.2.6 2.5 1.2 4 1.7l-3.1 10.2-4.2-2.6 4.1 1.3.3-.9-6.3-2.1zm11.6-19c3.3-2.7.7-3.6 2.2-5.7-2.9.6-1.4 3.8-2.2 5.7m6.6 1.8c3.3-2.7.7-3.6 2.2-5.7-2.8.5-1.3 3.7-2.2 5.7M23 7.4c1.1-2.5-.9-6.7 2.8-7.5-1.9 2.9 1.5 4-2.8 7.5"/></svg>'};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.2 42.6"><defs><path id="a" transform="rotate(-14.224 24.499 23.09)" d="M2.9 3.6h43.2v39H2.9z"/></defs><path class="st0" d="M1.8 17.7c-2.2-1.9-2.4-5.2-.4-7.4 1.9-2.2 5.2-2.4 7.4-.4.1.1.2.2.5.3 2.5 1 6.8.7 11.3-.5 4.5-1.2 8.7-3.1 10.7-5.4.3-.4.6-.7.7-1 1.1-2.7 4.1-4 6.8-2.9s4 4.1 2.9 6.8c-.6 1.5-1.5 2.8-2.6 4.1-2.3 2.6-5.8 4.8-9.6 6.5l1.9 7.4c.4 2.6-1.4 3.8-3.4 4.4l4 11.6c-2.5.8-2.7.8-5.2 1.3l-2-12.1-.3.1c-2.1.4-4.4.3-5.3-2.2L17.4 21c-4.4.5-8.7.2-11.9-1.1-1.5-.6-2.7-1.3-3.7-2.2m5 1.1c-.1-2.7.6-5.1 2.2-7.3-3.9 1.1-3.8 5.8-2.2 7.3m29.4-7.1c-2.3-1.3-4-3.2-5.1-5.6-1.1 3.9 3 6.2 5.1 5.6m-10.4 5.4c-1.6-2.2-2.4-4.6-2.4-7.2-2.6 3.1.2 6.9 2.4 7.2m-10.6 2.4c-.9-2.5-1.1-5-.4-7.6-3.3 2.3-1.6 6.7.4 7.6m13-1.3c-.7.3-1.5.6-2.2.8l2.1 7.1c.6-.3 1-.7 1.2-1.3l-1.1-6.6zm-3.6 1.3c-.5.1-.9.3-1.4.4-.3.1-.5.1-.8.2l2.2 7.3c.6-.1.9-.1 1.5-.4l-1.5-7.5zm-3.6.9c-.8.2-1.5.3-2.3.4l2.1 6.1c.5.4 1 .6 1.7.6L21 20.4z"/></svg>'};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.3 45.7"><defs><path id="a" d="M0 0h29.3v45.7H0z"/></defs><path class="st0" d="M29.3 13l-.1 1.2s-.3 0-.8.3.2 4.1-2.9 7.8c-.7.8-1.9 1.5-3.4 2l4.1 21.2-1.4.3-2.8-11H7.3l-1.1 4.4.9.6c.6.6 1 1.5 1 2.5s-.4 1.8-1 2.5c-.6.6-1.5 1-2.5 1s-1.8-.4-2.5-1c-.6-.6-1-1.5-1-2.5s.4-1.8 1-2.5c.6-.6 1.5-1 2.4-1l2.8-14.5c-1.5-.5-2.7-1.1-3.4-2-3.1-3.7-2.4-7.5-2.9-7.8-.5-.3-.8-.3-.8-.3L0 13h29.3m-9.4-1c-1.2-5.2-6.1-3.7-8.4-6.4-1.1-1.3-1.3-2.5-1.3-2.5-1.9 2.8-1.3 6.1.1 8.9h2.3c-.6-1.2-1.5-2.7-1.4-4 1.7 1.8 5.8 1.4 6.2 4.1h2.5zM9 12H5.3c-.5-2 1.9-2.9 2.2-4.7.2 2.1.7 3.3 1.5 4.7m12.3 0c-.8-3.7-2.2-3-2.9-5 .9 1.6 5.8.6 6.8 5h-3.9zm-7.8-6.1C11 4.5 10.9 2.6 10.8 0c1.7 2 2 3.5 2.7 5.9m8.2 27.7l-2.2-8.8c-3.1.5-6.7.5-9.8 0l-2.2 8.8h14.2zM5.8 41c-.3-.3-.8-.5-1.2-.5-.5 0-.9.2-1.2.5-.3.3-.5.8-.5 1.2 0 .5.2.9.5 1.2.2.4.6.6 1.1.6.5 0 .9-.2 1.2-.5.3-.3.5-.8.5-1.2.1-.6-.1-1-.4-1.3"/></svg>'};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.9 46.1"><defs><path id="a" d="M0 0h46.9v46.1H0z"/></defs><path class="st0" d="M30.5 2.3l-1.8 2.1.1.1c2.1 2.1 2.1 3.9 2.1 3.9l-4.4 2.2s-.1-1.4-1.1-2.4l-1.9 2.2c2 2.1 2 3.8 2 3.8l-4.4 2.2s-.1-1.2-.9-2.2l-1.7 1.9.1.1c2.1 2.1 2.1 3.9 2.1 3.9l-4.4 2.2s-.2-1.4-1.1-2.4l-1.7 1.9.2.2c2.1 2.1 2.1 3.9 2.1 3.9l-4.4 2.2s-.2-1.5-1.2-2.5l-2.6 3c.4.6.6 1.2.7 1.9.1.7-.1 1.5-.4 2.1-.3.6-.8 1.1-1.4 1.5-.9.6-2 .8-3.1.6-.9-.2-1.7-.6-2.2-1.2-.4-.4-.7-.9-.9-1.5-.2-.6-.2-1.2-.1-1.8.1-.7.5-1.3 1.1-1.9L3 29.8c-.2.2-.4.5-.4.7v.5c.1.2.2.3.3.5.3.3.6.4 1 .5.5.1.9 0 1.2-.2.2-.1.4-.4.5-.6.1-.2.2-.5.1-.7 0-.4-.2-.8-.7-1.1l-1-.8.9-1 2.8-3.1c-.9-.1-1.7 0-1.7 0l.3-4.4s2.5-.1 4.8.5l1.6-1.8c-1-.1-1.8 0-1.8 0l.3-4.4s2.6-.1 4.9.6l1.7-1.9c-1.1-.2-2.1-.1-2.1-.1l.3-4.7s2.9-.1 5.2.7l1.7-2c-1-.1-1.9 0-1.9 0l.3-4.4s2.7-.1 5 .6L28.5.7l2.4-.7-.4 2.3zm-1.2 18.1s1.6.6 2.5.2l-1.6 1.8c-.5-.4-1.2-.7-1.4-.7-.5.1-1.3 4.9-1.3 4.9s.7.7 1.2.7c-.2.2-.4.4-.5.4-.5 0-1-.7-1-.7s.1-.7.3-1.6l-.2.2c.6-1.5.9-4.2.6-4.4-.4-.3-3.2-1.1-4-.4-.8.7.3 6.1.3 6.1s1.7.3 2.5-.3c0 0 .1 0 .1-.1-.1.2-.2.4-.4.5-.2.1-.4.2-.7.2l-1.8 2c-.4-.4-.8-.7-1.4-.9-3-.8-7.1 1.2-8.2 4.1-.7 1.9.9 4 1.8 4.1 1 .1 2.3-1.4 2.3-1.4l-1-.2s.4-.5.5-.5c.1 0 .4.1.7.2.3 1 1.4 4.2 1.4 4.2s1.4-.6 2-1c.7-.3 2-1.1 2-1.1s-.9-1.2-1.7-2.3l.9-1c-.5.3-1 .4-1.3.5-.2-.2-.3-.4-.4-.6l-.1-.4c.1-.2.1-.5.2-.5.1-.1.7-.1.7-.1l-.4.9s2.1-.2 2.6-1c.1-.1.1-.2.1-.3l5.4-6c.1-.2.2-.3.3-.4-.6.9-1.2 2-1.2 2s.2.5.5.9 2.7-1.5 3.2-1.9c.5-.5-.6-2.1-1.2-2.3l6.4-7.1c.4.3.7.6.7.6s1.8-2.8 2.4-3.7c.3 0 .7-.1.8 0 .1.1.3.6.3.6h-1s.9 1.9 1.9 2c1 .1 3.1-1.4 2.9-3.5-.1-1.2-.7-2.3-1.5-3.3L46 8.1l.9-2.1-2.3.6-1.5 1.6C42 7.5 40.8 7 39.6 7c-2 0-3.4 2.3-3.2 3.2.2.9 2.2 1.7 2.2 1.7l-.1-1s.6.2.7.3v.7c-.8.7-3.4 2.8-3.4 2.8l.8.8-1 1.1c-.3-.2-.6-.4-.7-.4-.3 0-1 1.6-1.5 3l-.8.8c.9-1.3 1.8-4.1 1.5-4.4-.3-.3-3-1.7-3.9-1.1-1 .5-.9 5.9-.9 5.9m6.2 4.1l-.1-.9s2.6-1.5 2.8-1.1c.2.4-.5 1.5-.7 1.9 0 0 .5 2.8.4 3.6-.1.8-1.3-1.2-1.6-1.4-.2-.2-1.8 1.6-2.1 1.5-.3.1 1.3-3.6 1.3-3.6m-1.1-2.4s2.5-3.2 3.1-2.9c.6.3 1.3 2.1.8 2.5-.6.3-3.3 1.7-3.6 1.3-.2-.4-.3-.9-.3-.9M31 29.8s-.9 3.9-.6 3.9c.3 0 1.5-2 1.8-1.9.2.1 1.8 1.9 1.8 1.1 0-.8-1-3.5-1-3.5.2-.4.6-1.6.4-2-.4-.3-2.6 1.6-2.6 1.6l.2.8zm-11.7 8.5l-1.5 1.6c.4.6.6 1.2.7 1.9.1.7-.1 1.5-.4 2.1-.3.6-.8 1.2-1.4 1.5-.9.6-2 .8-3.1.6-.9-.2-1.7-.6-2.2-1.2-.4-.4-.7-.9-.9-1.5-.2-.6-.2-1.2-.1-1.8.1-.7.5-1.3 1.1-1.9l1.8 1.8c-.2.2-.4.5-.4.7v.5c.1.2.2.3.3.5.3.3.6.4 1 .5.5.1.9 0 1.2-.2.2-.1.4-.4.5-.6.1-.2.2-.5.1-.7 0-.4-.2-.8-.7-1.1l-1-.8.9-1 3.2-3.6c.3.7.7 1.9.9 2.7"/></svg>'};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 69"><path class="st0" d="M19 7.3H7.2V16h5.4c2.2 0 3.9.5 5.1 1.6 1.2 1.1 1.8 2.5 1.8 4.3 0 1.8-.6 3.2-1.8 4.3-1.2 1.1-2.9 1.6-5.1 1.6H6.4V6.5H19v.8zM7.2 16.8V27h5.4c2 0 3.6-.5 4.6-1.5s1.5-2.2 1.5-3.7c0-1.4-.5-2.6-1.5-3.6s-2.5-1.5-4.6-1.5H7.2zM37.3 21.4H26.9l-2.4 6.4h-.9l8-21.4h1l8 21.4h-.9l-2.4-6.4zm-10.1-.7H37l-4.5-12-.4-1.2H32l-.4 1.2-4.4 12zM61.8 27h1.8v5.9h-.8v-5.1H45.3v5.1h-.8V27h.5c1.4 0 2.6-1.2 3.7-3.5 1-2.4 1.7-5.8 2-10.2l.6-6.8h10.6V27zM51.4 13.3c-.2 3.5-.7 6.4-1.4 8.8-.7 2.4-1.7 4-2.8 4.9H61V7.3h-9l-.6 6zM70.3 27.9l-1 3.7h-.7l1-3.6v-2.5h.8v2.4zM100.8 27.8h-.8V17.6H86.4v10.2h-.8V6.5h.8v10.4H100V6.5h.8v21.3zM119.2 17.1h-10.7V27h12.2v.8h-13V6.5h13v.8h-12.2v9h10.7v.8zM134.4 27.8h-.9l5.1-9.9-.1-.1c-1.4-.4-2.4-1-3.1-1.9-.7-.9-1.1-2-1.1-3.3 0-1.9.6-3.5 1.8-4.5 1.2-1.1 2.9-1.6 5.1-1.6h6.2v21.4h-.8v-9.7h-7.3l-4.9 9.6zm12.2-20.5h-5.4c-2 0-3.5.5-4.6 1.4-1 .9-1.6 2.2-1.6 3.9 0 1.4.5 2.6 1.4 3.5.9.9 2.2 1.3 3.8 1.3h6.3V7.3zM153.9 27.8V6.5h5.6c2.2 0 3.9.5 5.1 1.4 1.2.9 1.8 2.3 1.8 4.1 0 1.3-.3 2.3-1 3.2-.7.9-1.6 1.4-2.8 1.6 1.3.2 2.4.8 3.4 1.7.9 1 1.4 2.1 1.4 3.4 0 1.9-.6 3.3-1.8 4.3s-2.8 1.5-4.8 1.5h-6.9zm.8-11.3h5.1c1.9 0 3.4-.4 4.4-1.1 1-.8 1.5-1.9 1.5-3.5 0-1.5-.5-2.7-1.6-3.5-1-.8-2.6-1.2-4.6-1.2h-4.8v9.3zm0 .8V27h6.2c1.8 0 3.2-.4 4.3-1.3 1-.9 1.6-2.1 1.6-3.7 0-1.3-.5-2.4-1.5-3.3-1-.9-2.4-1.4-4.2-1.4h-6.4zM188.4 6.5v21.4h-.8V7.3h-10.4l-.6 8.5c-.2 4.6-.7 7.8-1.4 9.5-.7 1.7-2 2.6-4 2.6h-.5V27h.5c1.5 0 2.6-.7 3.2-2.2.6-1.5 1.1-4.5 1.3-9l.6-9.3h12.1zM194.7 27.8h-.9l5.1-9.9-.1-.1c-1.4-.4-2.4-1-3.1-1.9-.7-.9-1.1-2-1.1-3.3 0-1.9.6-3.5 1.8-4.5 1.2-1.1 2.9-1.6 5.1-1.6h6.2v21.4h-.7v-9.7h-7.3l-5 9.6zM207 7.3h-5.4c-2 0-3.5.5-4.6 1.4-1 .9-1.6 2.2-1.6 3.9 0 1.4.5 2.6 1.4 3.5.9.9 2.2 1.3 3.8 1.3h6.3V7.3zM225.8 17.1h-10.7V27h12.2v.8h-13V6.5h13v.8h-12.2v9h10.7v.8zM247.9 7.3h-7.8v20.6h-.8V7.3h-7.8v-.8h16.3v.8zM266.1 21.3c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6-1.4-1.7-2.1-4-2.1-6.8v-3.2c0-2.8.7-5.1 2.1-6.8 1.4-1.7 3.3-2.6 5.6-2.6 2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5-1.2-1-2.8-1.6-4.9-1.6-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.7zM271.8 27.8h-.9l5.1-9.9-.1-.1c-1.4-.4-2.4-1-3.1-1.9-.7-.9-1.1-2-1.1-3.3 0-1.9.6-3.5 1.8-4.5 1.2-1.1 2.9-1.6 5.1-1.6h6.2v21.4h-.8v-9.7h-7.3l-4.9 9.6zM284 7.3h-5.4c-2 0-3.5.5-4.6 1.4-1 .9-1.6 2.2-1.6 3.9 0 1.4.5 2.6 1.4 3.5.9.9 2.2 1.3 3.8 1.3h6.3V7.3zM315.4 6.5v21.4h-.8V7.3h-10.4l-.6 8.5c-.2 4.6-.7 7.8-1.4 9.5-.7 1.7-2 2.6-4 2.6h-.5V27h.5c1.5 0 2.6-.7 3.2-2.2.6-1.5 1.1-4.5 1.3-9l.6-9.3h12.1zM333.7 17.1H323V27h12.2v.8h-13V6.5h13v.8H323v9h10.7v.8zM344.6 17.4h-3.3v10.4h-.8V6.5h.8v10.1h3.5l9.1-10.1h.9v.1l-9.4 10.6 10 10.6v.1h-.9l-9.9-10.5zM373.3 21.4h-10.4l-2.4 6.4h-.9l8-21.4h1l8 21.4h-.9l-2.4-6.4zm-10.2-.7h9.9l-4.5-12-.4-1.2h-.1l-.4 1.2-4.5 12zM382.3 18.7v9.2h-.8V6.5h6.7c2.2 0 3.9.6 5.1 1.7 1.2 1.1 1.8 2.6 1.8 4.4 0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8h5.9c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM415.2 21.3c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6-1.4-1.7-2.1-4-2.1-6.8v-3.2c0-2.8.7-5.1 2.1-6.8 1.4-1.7 3.3-2.6 5.6-2.6 2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5-1.2-1-2.8-1.6-4.9-1.6-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.7zM435.3 7.3h-7.8v20.6h-.8V7.3H419v-.8h16.3v.8zM440.5 27.8V6.5h5.6c2.2 0 3.9.5 5.1 1.4 1.2.9 1.8 2.3 1.8 4.1 0 1.3-.3 2.3-1 3.2-.7.9-1.6 1.4-2.8 1.6 1.3.2 2.4.8 3.4 1.7.9 1 1.4 2.1 1.4 3.4 0 1.9-.6 3.3-1.8 4.3-1.2 1-2.8 1.5-4.8 1.5h-6.9zm.7-11.3h5.1c1.9 0 3.4-.4 4.4-1.1 1-.8 1.5-1.9 1.5-3.5 0-1.5-.5-2.7-1.6-3.5-1-.8-2.6-1.2-4.6-1.2h-4.8v9.3zm0 .8V27h6.2c1.8 0 3.2-.4 4.3-1.3 1-.9 1.6-2.1 1.6-3.7 0-1.3-.5-2.4-1.5-3.3-1-.9-2.4-1.4-4.2-1.4h-6.4zM471.2 17.1h-10.7V27h12.2v.8h-13V6.5h13v.8h-12.2v9h10.7v.8zM493.2 27.8h-.8V17.6h-13.6v10.2h-.8V6.5h.8v10.4h13.6V6.5h.8v21.3zM515.3 27.8h-.8V17.6h-13.6v10.2h-.8V6.5h.8v10.4h13.6V6.5h.8v21.3zM522.9 16h5.4c2.2 0 3.9.5 5.1 1.6 1.2 1.1 1.8 2.5 1.8 4.3 0 1.8-.6 3.2-1.8 4.3-1.2 1.1-2.9 1.6-5.1 1.6h-6.2V6.5h.8V16zm0 .8V27h5.4c2 0 3.6-.5 4.6-1.5 1-1 1.5-2.2 1.5-3.7 0-1.4-.5-2.6-1.5-3.6s-2.5-1.5-4.6-1.5h-5.4zm17.6 11h-.8V6.5h.8v21.3zM548.5 6.5l8.7 20.1h.1l8.8-20.1h1.2v21.4h-.8v-20h-.1l-8.8 20h-.6L548.3 8h-.1v19.9h-.8V6.5h1.1zM597.6 21.3c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6-1.4-1.7-2.1-4-2.1-6.8v-3.2c0-2.8.7-5.1 2.1-6.8 1.4-1.7 3.3-2.6 5.6-2.6 2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5-1.2-1-2.8-1.6-4.9-1.6-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.7zM604.4 18.7v9.2h-.8V6.5h6.7c2.2 0 3.9.6 5.1 1.7s1.8 2.6 1.8 4.4c0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8h5.9c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM634.2 17.1h-10.7V27h12.2v.8h-13V6.5h13v.8h-12.2v9h10.7v.8zM657.2 27h1.8v5.9h-.8v-5.1h-17.4v5.1h-.8V27h.5c1.4 0 2.6-1.2 3.7-3.5 1-2.4 1.7-5.8 2-10.2l.6-6.8h10.6V27zm-10.4-13.7c-.2 3.5-.7 6.4-1.4 8.8-.7 2.4-1.7 4-2.8 4.9h13.8V7.3h-9l-.6 6zM678.3 21.3c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6-1.4-1.7-2.1-4-2.1-6.8v-3.2c0-2.8.7-5.1 2.1-6.8 1.4-1.7 3.3-2.6 5.6-2.6 2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5C674.6 7.5 673 7 671 7c-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.6zM698.4 7.3h-7.8v20.6h-.8V7.3H682v-.8h16.3v.8zM703.5 27.8V6.5h5.6c2.2 0 3.9.5 5.1 1.4 1.2.9 1.8 2.3 1.8 4.1 0 1.3-.3 2.3-1 3.2-.7.9-1.6 1.4-2.8 1.6 1.3.2 2.5.8 3.4 1.7.9 1 1.4 2.1 1.4 3.4 0 1.9-.6 3.3-1.8 4.3-1.2 1-2.8 1.5-4.8 1.5h-6.9zm.8-11.3h5.1c1.9 0 3.4-.4 4.4-1.1 1-.8 1.5-1.9 1.5-3.5 0-1.5-.5-2.7-1.6-3.5-1-.8-2.6-1.2-4.6-1.2h-4.8v9.3zm0 .8V27h6.2c1.8 0 3.2-.4 4.3-1.3 1-.9 1.6-2.1 1.6-3.7 0-1.3-.5-2.4-1.5-3.3-1-.9-2.4-1.4-4.2-1.4h-6.4zM738.2 18.8c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9v-3.2c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM745.4 6.5l8.7 20.1h.1L763 6.5h1.2v21.4h-.8v-20h-.1l-8.8 20h-.6L745.2 8h-.1v19.9h-.8V6.5h1.1zM794.8 6.5h.8v21.4h-.8V8h-.1L781 27.8h-.8V6.5h.8v19.8h.1l13.7-19.8zM803.6 6.5l8.7 20.1h.1l8.8-20.1h1.2v21.4h-.8v-20h-.1l-8.8 20h-.7L803.3 8h-.1v19.9h-.8V6.5h1.2zM840.7 17.1H830V27h12.2v.8h-13V6.5h13v.8H830v9h10.7v.8zM853 17.7h-4.6v10.2h-.8V6.5h.8v10.4h4.6v.8zm16.9 1.1c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9v-3.2c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5s2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3s3 2.3 5.4 2.3c2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM889.5 7.3h-7.8v20.6h-.7V7.3h-7.8v-.8h16.3v.8zM907.8 21.3c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6s-2.1-4-2.1-6.8v-3.2c0-2.8.7-5.1 2.1-6.8s3.3-2.6 5.6-2.6c2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5-1.2-1-2.8-1.6-4.9-1.6-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.7zM913.4 27.8h-.9l5.1-9.9-.1-.1c-1.4-.4-2.4-1-3.1-1.9-.7-.9-1.1-2-1.1-3.3 0-1.9.6-3.5 1.8-4.5 1.2-1.1 2.9-1.6 5.1-1.6h6.2v21.4h-.8v-9.7h-7.3l-4.9 9.6zm12.3-20.5h-5.4c-2 0-3.5.5-4.6 1.4-1 .9-1.6 2.2-1.6 3.9 0 1.4.5 2.6 1.4 3.5.9.9 2.2 1.3 3.8 1.3h6.3V7.3zM957.1 27.8h-.8V7.3h-13.6v20.6h-.8V6.5h15.2v21.3zM964.7 18.7v9.2h-.8V6.5h6.7c2.2 0 3.9.6 5.1 1.7 1.2 1.1 1.8 2.6 1.8 4.4 0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8h5.9c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM998.5 18.8c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9v-3.2c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.7-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM1018 7.3h-7.8v20.6h-.8V7.3h-7.8v-.8h16.3v.8zM1037.7 6.5h.8v21.4h-.8V8h-.1l-13.7 19.9h-.8V6.5h.8v19.8h.1l13.7-19.8zM1045.4 27.8V6.5h5.6c2.2 0 3.9.5 5.1 1.4s1.8 2.3 1.8 4.1c0 1.3-.3 2.3-1 3.2-.7.9-1.6 1.4-2.8 1.6 1.3.2 2.4.8 3.4 1.7.9 1 1.4 2.1 1.4 3.4 0 1.9-.6 3.3-1.8 4.3s-2.8 1.5-4.8 1.5h-6.9zm.8-11.3h5.1c1.9 0 3.4-.4 4.4-1.1 1-.8 1.5-1.9 1.5-3.5 0-1.5-.5-2.7-1.6-3.5-1-.8-2.6-1.2-4.6-1.2h-4.8v9.3zm0 .8V27h6.2c1.8 0 3.2-.4 4.3-1.3 1-.9 1.6-2.1 1.6-3.7 0-1.3-.5-2.4-1.5-3.3-1-.9-2.4-1.4-4.2-1.4h-6.4zM1080 18.8c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9v-3.2c0-2.9.7-5.2 2.1-6.8s3.4-2.5 5.9-2.5c2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM1101.3 27.8h-.8V7.3h-13.6v20.6h-.8V6.5h15.2v21.3zM1123.5 18.8c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9v-3.2c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM1133.7 17.4h-3.3v10.4h-.8V6.5h.8v10.1h3.5l9.1-10.1h.9v.1l-9.4 10.6 10 10.6v.1h-.9l-9.9-10.5zM1162.4 21.4H1152l-2.4 6.4h-.9l8-21.4h1l8 21.4h-.9l-2.4-6.4zm-10.2-.7h9.9l-4.5-12-.4-1.2h-.1l-.4 1.2-4.5 12zM1177 16.5c2.4 0 4.2-.4 5.4-1.2 1.2-.8 1.7-1.9 1.7-3.4s-.6-2.7-1.8-3.6c-1.2-.9-2.9-1.3-5.3-1.3-1.9 0-3.5.5-4.8 1.4-1.3.9-1.9 2.2-1.9 3.7h-.7V12c-.1-1.7.6-3.1 2.1-4.2 1.4-1.1 3.2-1.6 5.3-1.6 2.4 0 4.3.5 5.7 1.5 1.4 1 2.1 2.4 2.1 4.3 0 1.2-.4 2.2-1.2 3.1-.8.9-1.9 1.5-3.4 1.9 1.7.3 2.9.9 3.7 1.8.8.9 1.2 2 1.2 3.4 0 1.9-.8 3.3-2.3 4.4-1.5 1.1-3.5 1.6-5.9 1.6-2.1 0-3.9-.5-5.5-1.6-1.5-1.1-2.3-2.6-2.2-4.5V22h.7c0 1.6.6 2.9 1.9 3.9 1.3 1 3 1.5 5.1 1.5 2.3 0 4.1-.5 5.4-1.4 1.3-.9 1.9-2.2 1.9-3.8 0-1.7-.6-2.9-1.9-3.7-1.2-.8-3.1-1.2-5.6-1.2h-2.7v-.8h3zM1202.5 21.4h-10.4l-2.4 6.4h-.9l8-21.4h1l8 21.4h-.9l-2.4-6.4zm-10.1-.7h9.9l-4.5-12-.4-1.2h-.1l-.4 1.2-4.5 12zM1226 27.8h-.8V17.6h-13.6v10.2h-.8V6.5h.8v10.4h13.6V6.5h.8v21.3zM1247.5 6.5h.8v21.4h-.8V8h-.1l-13.7 19.9h-.8V6.5h.8v19.8h.1l13.7-19.8zM1254.6 27.8h-.9l5.1-9.9-.1-.1c-1.4-.4-2.4-1-3.1-1.9-.7-.9-1.1-2-1.1-3.3 0-1.9.6-3.5 1.8-4.5 1.2-1.1 2.9-1.6 5.1-1.6h6.2v21.4h-.8v-9.7h-7.3l-4.9 9.6zm12.2-20.5h-5.4c-2 0-3.5.5-4.6 1.4-1 .9-1.6 2.2-1.6 3.9 0 1.4.5 2.6 1.4 3.5.9.9 2.2 1.3 3.8 1.3h6.3V7.3zM1274.7 27.8h-1.3v-1.9h1.3v1.9zM21.7 62.2h-.8V41.7H7.3v20.6h-.8V40.9h15.2v21.3zM42.3 51.5H31.6v9.9h12.2v.8h-13V40.9h13v.8H31.6v9h10.7v.8zM52.1 53.1v9.2h-.8V40.9H58c2.2 0 3.9.6 5.1 1.7 1.2 1.1 1.8 2.6 1.8 4.4 0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8H58c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM84.1 51.5H73.4v9.9h12.2v.8h-13V40.9h13v.8H73.4v9h10.7v.8zM109.4 61.4h1.8v5.9h-.8v-5.1H92.9v5.1h-.8V61.4h.5c1.4 0 2.6-1.2 3.7-3.5 1-2.4 1.7-5.8 2-10.2l.6-6.8h10.6v20.5zM99 47.7c-.2 3.5-.7 6.4-1.4 8.8-.7 2.4-1.7 4-2.8 4.9h13.8V41.7h-9l-.6 6zM145 62.2h-.8V41.7h-13.6v20.6h-.8V40.9H145v21.3zM154.9 53.1v9.2h-.8V40.9h6.7c2.2 0 3.9.6 5.1 1.7s1.8 2.6 1.8 4.4c0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8h5.9c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM190 40.9h.8v21.4h-.8V42.4h-.1l-13.7 19.9h-.8V40.9h.8v19.8h.1L190 40.9zM201 40.9l8.7 20.1h.1l8.8-20.1h1.2v21.4h-.8v-20h-.1l-8.8 20h-.6l-8.7-19.9h-.1v19.9h-.8V40.9h1.1zM240.3 51.5h-10.7v9.9h12.2v.8h-13V40.9h13v.8h-12.2v9h10.7v.8zM264.6 62.2h-.8V52h-13.6v10.2h-.8V40.9h.8v10.4h13.6V40.9h.8v21.3zM285.2 51.5h-10.7v9.9h12.2v.8h-13V40.9h13v.8h-12.2v9h10.7v.8zM309.4 62.2h-.8V52H295v10.2h-.8V40.9h.8v10.4h13.6V40.9h.8v21.3zM333.1 40.9h.8v21.4h-.8V42.4h-.1l-13.7 19.9h-.8V40.9h.8v19.8h.1l13.7-19.8zM354.5 51.5h-10.7v9.9H356v.8h-13V40.9h13v.8h-12.2v9h10.7v.8zM364.7 40.9l8.7 20.1h.1l8.8-20.1h1.2v21.4h-.8v-20h-.1l-8.8 20h-.6l-8.7-19.9h-.1v19.9h-.8V40.9h1.1zM419.1 62.2h-.8V52h-13.6v10.2h-.8V40.9h.8v10.4h13.6V40.9h.8v21.3zM439.7 51.5H429v9.9h12.2v.8h-13V40.9h13v.8H429v9h10.7v.8zM463.6 53.2c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9V50c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3s4.1-.8 5.4-2.3c1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM484.5 41.7h-11.8v8.7h5.4c2.2 0 3.9.5 5.1 1.6 1.2 1.1 1.8 2.5 1.8 4.3 0 1.8-.6 3.2-1.8 4.3-1.2 1.1-2.9 1.6-5.1 1.6h-6.2V40.9h12.6v.8zm-11.8 9.5v10.3h5.4c2 0 3.6-.5 4.6-1.5s1.5-2.2 1.5-3.7c0-1.4-.5-2.6-1.5-3.6s-2.5-1.5-4.6-1.5h-5.4zM500.1 50.7l6.9-9.8h1l-7.4 10.5 7.7 10.9h-1L500.1 52l-7.2 10.3h-1l7.7-10.9-7.4-10.5h1l6.9 9.8zM529.6 53.2c0 2.9-.7 5.2-2.1 6.9s-3.4 2.5-5.9 2.5c-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9V50c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3s4.1-.8 5.4-2.3c1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM552.2 61.4h1.8v5.9h-.8v-5.1h-17.4v5.1h-.8V61.4h.5c1.4 0 2.6-1.2 3.7-3.5 1-2.4 1.7-5.8 2-10.2l.6-6.8h10.6v20.5zm-10.4-13.7c-.2 3.5-.7 6.4-1.4 8.8-.7 2.4-1.7 4-2.8 4.9h13.8V41.7h-9l-.6 6zM576 40.9h.8v21.4h-.8V42.4h-.1l-13.7 19.9h-.8V40.9h.8v19.8h.1L576 40.9zM587 40.9l8.7 20.1h.1l8.8-20.1h1.2v21.4h-.8v-20h-.1l-8.8 20h-.6l-8.7-19.9h-.1v19.9h-.8V40.9h1.1zM630.2 53.2c0 2.9-.7 5.2-2.1 6.9s-3.4 2.5-5.9 2.5c-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9V50c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3s4.1-.8 5.4-2.3c1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM664.9 62.2h-.8V41.7h-13.6v20.6h-.8V40.9h15.2v21.3zM674.8 53.1v9.2h-.8V40.9h6.7c2.2 0 3.9.6 5.1 1.7 1.2 1.1 1.8 2.6 1.8 4.4 0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8h5.9c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM710.9 53.2c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9V50c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM723.2 51.8H720v10.4h-.8V40.9h.8V51h3.5l9.1-10.1h.9v.1l-9.4 10.6 10 10.6v.1h-.9l-10-10.5zM755.5 53.2c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5s-2.1-4-2.1-6.9V50c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM779 62.2h-.8V52h-13.6v10.2h-.8V40.9h.8v10.4h13.6V40.9h.8v21.3zM802.5 55.7c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6s-2.1-4-2.1-6.8V50c0-2.8.7-5.1 2.1-6.8 1.4-1.7 3.3-2.6 5.6-2.6 2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5-1.2-1-2.8-1.6-4.9-1.6-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.7zM816.8 54.1l.8 1.5.3-.6 7.4-14.1h1L817 58.5c-.6 1.1-1.3 2.1-2.1 2.9-.8.8-1.9 1.2-3.3 1.2-.5 0-1-.1-1.7-.2-.6-.1-1.1-.3-1.4-.6l.2-.7c.4.2.8.4 1.3.5.5.1 1.1.2 1.6.2 1 0 1.8-.3 2.5-.9.7-.6 1.3-1.4 1.8-2.5l1-1.9-8.7-15.6h1l7.6 13.2zM847.4 40.9v21.4h-.8V41.7h-10.4l-.6 8.5c-.2 4.6-.7 7.8-1.4 9.5-.7 1.7-2 2.6-4 2.6h-.5v-.8h.5c1.5 0 2.6-.7 3.2-2.2.6-1.5 1.1-4.5 1.3-9l.6-9.3h12.1zM857.2 50.4h5.4c2.2 0 3.9.5 5.1 1.6 1.2 1.1 1.8 2.5 1.8 4.3 0 1.8-.6 3.2-1.8 4.3-1.2 1.1-2.9 1.6-5.1 1.6h-6.2V40.9h.8v9.5zm0 .8v10.3h5.4c2 0 3.6-.5 4.6-1.5 1-1 1.5-2.2 1.5-3.7 0-1.4-.5-2.6-1.5-3.6s-2.5-1.5-4.6-1.5h-5.4zM888.7 41.7H881v20.6h-.8V41.7h-7.8v-.8h16.3v.8zM910.7 40.9h.8v21.4h-.8V42.4h-.1l-13.7 19.9h-.8V40.9h.8v19.8h.1l13.7-19.8zM921.4 53.1v9.2h-.8V40.9h6.7c2.2 0 3.9.6 5.1 1.7s1.8 2.6 1.8 4.4c0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8h5.9c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM957.4 53.2c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5-1.4-1.7-2.1-4-2.1-6.9V50c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM965.7 62.2V40.9h5.6c2.2 0 3.9.5 5.1 1.4 1.2.9 1.8 2.3 1.8 4.1 0 1.3-.3 2.3-1 3.2-.7.9-1.6 1.4-2.8 1.6 1.3.2 2.4.8 3.4 1.7.9 1 1.4 2.1 1.4 3.4 0 1.9-.6 3.3-1.8 4.3s-2.8 1.5-4.8 1.5h-6.9zm.8-11.3h5.1c1.9 0 3.4-.4 4.4-1.1 1-.8 1.5-1.9 1.5-3.5 0-1.5-.5-2.7-1.6-3.5-1-.8-2.6-1.2-4.6-1.2h-4.8v9.3zm0 .8v9.8h6.2c1.8 0 3.2-.4 4.3-1.3 1-.9 1.6-2.1 1.6-3.7 0-1.3-.5-2.4-1.5-3.3-1-.9-2.4-1.4-4.2-1.4h-6.4zM998.8 55.9h-10.4l-2.4 6.4h-.9l8-21.4h1l8 21.4h-.9l-2.4-6.4zm-10.2-.8h9.9L994 43l-.4-1.2h-.1l-.4 1.2-4.5 12.1zM1020.7 41.7h-7.8v20.6h-.8V41.7h-7.8v-.8h16.3v.8zM1028.8 50.4h5.4c2.2 0 3.9.5 5.1 1.6 1.2 1.1 1.8 2.5 1.8 4.3 0 1.8-.6 3.2-1.8 4.3-1.2 1.1-2.9 1.6-5.1 1.6h-6.2V40.9h.8v9.5zm0 .8v10.3h5.4c2 0 3.6-.5 4.6-1.5 1-1 1.5-2.2 1.5-3.7 0-1.4-.5-2.6-1.5-3.6s-2.5-1.5-4.6-1.5h-5.4zM1063.6 55.7c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6s-2.1-4-2.1-6.8V50c0-2.8.7-5.1 2.1-6.8 1.4-1.7 3.3-2.6 5.6-2.6 2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5-1.2-1-2.8-1.6-4.9-1.6-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.7zM1071.5 62.2h-.9l5.1-9.9-.1-.1c-1.4-.4-2.4-1-3.1-1.9-.7-.9-1.1-2-1.1-3.3 0-1.9.6-3.5 1.8-4.5 1.2-1.1 2.9-1.6 5.1-1.6h6.2v21.4h-.8v-9.7h-7.3l-4.9 9.6zm12.3-20.5h-5.4c-2 0-3.5.5-4.6 1.4-1 .9-1.6 2.2-1.6 3.9 0 1.4.5 2.6 1.4 3.5.9.9 2.2 1.3 3.8 1.3h6.3V41.7zM1118.6 55.7c.1 2.3-.6 4-2 5.1-1.4 1.2-3.2 1.7-5.4 1.7-2.3 0-4.2-.9-5.6-2.6s-2.1-4-2.1-6.8V50c0-2.8.7-5.1 2.1-6.8 1.4-1.7 3.3-2.6 5.6-2.6 2.2 0 4 .6 5.4 1.7 1.4 1.2 2 2.8 2 5v.1h-.7c0-1.9-.6-3.4-1.8-4.5-1.2-1-2.8-1.6-4.9-1.6-2.1 0-3.8.8-5 2.4-1.3 1.6-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.2 1.3 1.6 2.9 2.4 5 2.4s3.7-.5 4.9-1.5c1.2-1 1.8-2.5 1.8-4.5h.7zM1138.5 62.2V40.9h5.6c2.2 0 3.9.5 5.1 1.4 1.2.9 1.8 2.3 1.8 4.1 0 1.3-.3 2.3-1 3.2-.7.9-1.6 1.4-2.8 1.6 1.3.2 2.4.8 3.4 1.7.9 1 1.4 2.1 1.4 3.4 0 1.9-.6 3.3-1.8 4.3s-2.8 1.5-4.8 1.5h-6.9zm.8-11.3h5.1c1.9 0 3.4-.4 4.4-1.1 1-.8 1.5-1.9 1.5-3.5 0-1.5-.5-2.7-1.6-3.5-1-.8-2.6-1.2-4.6-1.2h-4.8v9.3zm0 .8v9.8h6.2c1.8 0 3.2-.4 4.3-1.3 1-.9 1.6-2.1 1.6-3.7 0-1.3-.5-2.4-1.5-3.3-1-.9-2.4-1.4-4.2-1.4h-6.4zM1160.7 53.1v9.2h-.8V40.9h6.7c2.2 0 3.9.6 5.1 1.7 1.2 1.1 1.8 2.6 1.8 4.4 0 1.9-.6 3.3-1.8 4.4-1.2 1.1-2.9 1.7-5.1 1.7h-5.9zm0-.8h5.9c2 0 3.5-.5 4.6-1.5 1-1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8-2.5-1.5-4.6-1.5h-5.9v10.6zM1191.1 55.9h-10.4l-2.4 6.4h-.9l8-21.4h1l8 21.4h-.9l-2.4-6.4zm-10.1-.8h9.9l-4.5-12-.4-1.2h-.1l-.4 1.2-4.5 12zM1212.7 40.9v21.4h-.8V51.7c-1 .3-2 .5-3 .7-1 .2-1.9.2-2.9.2-2.3 0-4.1-.5-5.3-1.5-1.2-1-1.8-2.7-1.8-5V41h.8v5c0 2 .5 3.5 1.6 4.4 1 .9 2.6 1.4 4.7 1.4 1 0 1.9-.1 2.9-.2s2-.4 3-.7v-10h.8zM1237 53.2c0 2.9-.7 5.2-2.1 6.9-1.4 1.7-3.4 2.5-5.9 2.5-2.5 0-4.5-.8-5.9-2.5s-2.1-4-2.1-6.9V50c0-2.9.7-5.2 2.1-6.8 1.4-1.7 3.4-2.5 5.9-2.5 2.5 0 4.5.8 5.9 2.5 1.4 1.7 2.2 4 2.2 6.8v3.2zm-.8-3.3c0-2.6-.6-4.7-1.9-6.2-1.3-1.5-3.1-2.3-5.4-2.3-2.3 0-4.1.8-5.4 2.3-1.3 1.5-1.9 3.6-1.9 6.2v3.2c0 2.6.6 4.7 1.9 6.3 1.3 1.5 3 2.3 5.4 2.3 2.3 0 4.1-.8 5.4-2.3 1.3-1.5 1.9-3.6 1.9-6.3v-3.2zM1246.5 40.9l8.7 20.1h.1l8.8-20.1h1.2v21.4h-.8v-20h-.1l-8.8 20h-.6l-8.7-19.9h-.1v19.9h-.8V40.9h1.1zM1274.9 62.2h-1.3v-1.9h1.3v1.9z"/></svg>'};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.1 57.6"><defs><path id="a" d="M0 0h67.1v57.6H0z"/></defs><path class="st0" d="M67.1 22.1L41.3 0v10.6C32.3 11.5.2 17.5 0 57.7c0 0 7.8-25.3 41.3-26.2v12.8l25.8-22.2z"/></svg>'};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 172.8 143.4"><path class="st0" d="M158 0H86.8c17.1 9.3 35.7 25.3 36.4 49.7.9 27.1-14.1 44.9-36.4 49.2-29 5.6-44.2-12.9-46.8-27.5-1.2-7-.3-14.8 3-20.7 4.9-8.8 14.9-14 25.8-11.7 11.1 2.3 16.8 10.2 17.3 18.5.4 7.3-3.7 13.7-9.3 16-3.2 1.3-7.8 1.3-11-.6-3.9-2.2-6-7.2-3-10.8 2.4-3 10.8-2.5 10.4-10.8-.2-4-4.4-8-10.6-7.7-6.5.3-10.9 3.5-13.9 7.5-7.3 9.7-5.6 25.1 5.3 34.6 5.4 4.7 16.6 13.1 38.2 5.3 10.6-3.8 17-12.2 20-19.8 8.7-21.7-.4-40.6-11-51.2C80-1.6 46.8 3.8 31.7 12.9c-47.5 28.7-30 81.3-20.5 95.6 18.2 27.3 49.4 35.2 72.2 34.9 20.9-.3 84.9-15.2 89.4-87.3 1.3-21.9-8.2-43.7-14.8-56.1"/></svg>'};

/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[46]);


// WEBPACK FOOTER //
// static/js/app.1c6aded515f7ffc9c877.js